<template>
  <hm-content title="">
    <div class="flex flex-start mb10">
      当前供货商: <span class="primary">{{ storeNames }}</span>
    </div>
    <div class="table-panel flex flex-between flex-wrap">
      <div class="mr10">
        <el-button type="primary" size="small" @click="addAct"
          >添加活动
        </el-button>
        <!-- <el-button type="primary" size="small" @click="step3Products"
          >测试活动
        </el-button> -->
        <!-- <el-button type="primary" size="small" @click="brokerage"
          >推会员返佣</el-button
        > -->
      </div>
      <div class="flex text-right item-center flex-wrap">
        <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="选择商户"
          v-model="searchCondition.storeCode"
          style="width: 200px"
          :remote-method="remoteMethod"
          filterable
          remote
        >
          <el-option
            v-for="item in storeBasicInfoListBoxList"
            :key="item.storeCode"
            :label="item.storeName"
            :value="item.storeCode"
          ></el-option>
        </el-select>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.keyWords"
          size="small"
          placeholder="请输入"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width: 100px"
            v-model="searchCondition.queryType"
          >
            <el-option label="商品名" value="goodsName"></el-option>
            <!-- <el-option label="货号" value="goods_sn"></el-option> -->
            <el-option label="商品条码" value="goodsBarcode"></el-option>
          </el-select>
        </el-input>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="searchCondition.rewardName"
          placeholder="请输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-cascader
          clearable
          class="mr10"
          ref="cascader"
          v-model="searchCondition.applyDepartIds"
          :props="propss"
          :show-all-levels="false"
          size="small"
          placeholder="请选择机构"
        ></el-cascader>
        <el-select
          size="small"
          clearable
          placeholder="选择活动上下线"
          v-model="searchCondition.enabledState"
          class="mr10"
          filterable
        >
          <el-option label="上线" value="yes"></el-option>
          <el-option label="下线" value="no"></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="flex flex-end item-center mt10 mb10">
      <span @click="openTimeBatch" class="pointer mr10">
        <span class="delete-icon hmicon icon-xitong"></span>批量修改
      </span>
      <span @click="batchDelete" class="pointer mr10">
        <span class="delete-icon hmicon icon-shanchu"></span>批量删除
      </span>
      <el-button type="success" size="small" @click="outputExcelMerchant"
        >导出商户在线活动</el-button
      >
    </div>
    <div class="table">
      <el-table
        border
        @selection-change="getDelChecked"
        ref="brandTable"
        :data="supplierRewardRuleInfoList.records"
        style="width: 100%"
        id="table"
        size="small"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rewardName"
          label="活动名称"
          width="150"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rewardMode"
          label="活动类型"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.rewardMode === 'fixed'">普通活动</div>
            <div v-if="scope.row.rewardMode === 'radio'">冲刺活动</div>
            <div v-if="scope.row.rewardMode === 'sub'">差异活动</div>
            <div v-if="scope.row.rewardMode === 'tiktokLikePas'">报名活动</div>
            <div v-if="scope.row.rewardMode === 'collocation'">搭配活动</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="applyDepartNames"
          show-overflow-tooltip
          label="活动组织"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="applyStoreCodesCount"
          label="适用商户数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsCount"
          label="适用商品数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="levelCount"
          label="活动规则阶梯"
        >
          <!-- <template slot-scope="scope">
            <div
              class="flex flex-center primary"
              v-if="scope.row.rewardMode === 'fixed'"
            >
              ¥{{ scope.row.rewardValue }}
            </div>
            <div
              class="flex flex-center blue"
              v-if="scope.row.rewardMode === 'radio'"
            >
              {{ scope.row.rewardValue }}%
            </div>
          </template> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="活动创建时间"
          width="135"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="timeFormatValue"
          label="奖励时段"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.timeFormatValue }}
            <span
              class="hmicon icon-shuru blue pointer"
              @click="editTime(scope.row)"
            >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="autoOfflineDaysLimt"
          label="自动下线"
        >
          <template slot-scope="scope">
            {{ scope.row.autoOfflineDaysLimt }}天
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsCount"
          label="上/下线"
        >
          <template slot-scope="scope">
            <div class="success" v-if="scope.row.enabledState === 'yes'">
              上线
            </div>
            <div class="danger" v-if="scope.row.enabledState === 'no'">
              <span v-if="scope.row.offlineMode === 'manual'"> 手动 </span>
              <span v-if="scope.row.offlineMode === 'day'"> 到期 </span>
              <span v-if="scope.row.offlineMode === 'balance'"> 余额不足 </span>
              下线
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="edit(scope.row, scope.$index)"
                >编辑
              </el-button>
              <el-button
                v-if="scope.row.rewardMode === 'tiktokLikePas'"
                size="small"
                type="text"
                @click="toApplyList(scope.row, scope.$index)"
                >预约列表
              </el-button>
              <el-button
                size="small"
                type="text"
                @click="edit(scope.row, scope.$index, 'detail')"
                v-if="
                  scope.row.rewardMode == 'collocation' &&
                  scope.row.auditState == 'wait'
                "
                >审核
              </el-button>
              <el-button
                size="small"
                type="text"
                @click="copy(scope.row, scope.$index)"
                >复制
              </el-button>
              <template v-if="scope.row.rewardMode !== 'collocation'">
                <el-button
                  size="small"
                  type="text"
                  @click="onLine(scope.row, 'yes')"
                  v-if="scope.row.enabledState === 'no'"
                  >上线
                </el-button>
                <el-button
                  size="small"
                  type="text"
                  @click="onLine(scope.row, 'no')"
                  v-else
                  >下线
                </el-button>
              </template>
              <template v-else>
                <el-button
                  size="small"
                  type="text"
                  v-if="scope.row.enabledState === 'yes'"
                  @click="onLine(scope.row, 'no')"
                  >下线
                </el-button>
              </template>
            </div>
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="toDetails(scope.row, scope.$index)"
                >详情
              </el-button>
              <el-button size="small" type="text" @click="del(scope.row)"
                >删除
              </el-button>
              <el-button
                size="small"
                type="text"
                @click="operationLog(scope.row, scope.$index)"
                >操作日志
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="supplierRewardRuleInfoList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="新增活动"
      width="80%"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div>
        <div slot="header">
          <hm-step
            :steps="stepsComputed"
            :step="step"
            :disabledFirst="disabledFirst"
            disabledNext
          ></hm-step>
        </div>
      </div>
      <!-- 第一步 -->
      <el-form
        v-show="step === 1"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="活动名称" prop="rewardName">
          <el-input
            type="text"
            v-model.trim="ruleForm.rewardName"
            clearable
            style="width: 600px"
            placeholder="请输入活动名称"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动类型" prop="rewardMode">
          <el-radio-group
            v-model="ruleForm.rewardMode"
            size="small"
            @change="rewardModeChange"
          >
            <el-radio label="fixed">普通活动</el-radio>
            <el-radio label="sub">差异活动</el-radio>
            <el-radio label="radio">冲刺活动</el-radio>
            <el-radio label="tiktokLikePas">报名活动</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="flex flex-end item-center" style="marginbottom: -20px" v-if="isShowRewards == 'fixed'">
            <div @click="outputExcelRewards" class="delete mr20 pointer">
              <span class="delete-icon hmicon icon-daochu"></span>
              导出模板
            </div>
            <!-- <el-button type="primary" size="small" class="open-file pointer"
                >导入活动规则
                <input
                  type="file"
                  class="pointer"
                  @change="importfs"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </el-button> -->
            <div class="delete mr20 pointer open-file">
              <span class="delete-icon hmicon icon-daoru"></span>
              导入活动规则
              <input type="file" @change="importfsRewards"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
            </div>
            <!-- <el-button type="text" size="small" @click="batchRemove"
              >批量删除
            </el-button>
            <el-button type="text" size="small" @click="allRemove"
              >全部删除
            </el-button> -->
          </div>
           <el-form-item label="奖励规则" prop="distributionType" v-if="ruleForm.rewardMode === 'fixed'">
          <el-radio-group
            v-model="ruleForm.distributionType"
            size="small"
            @change="rewardModeNewChange"
          >
            <el-radio label="group">按组奖励</el-radio>
            <el-radio label="item">按件奖励</el-radio>
          </el-radio-group>
           <div v-if="ruleForm.distributionType == 'item'">按件奖励规则：以申报件数匹配最高等级X单件金额</div>
        </el-form-item>
       <!-- 按组奖励 -->
        <el-form-item label="活动规则" prop="ruleRelModelList">
          <div class="table" v-if="ruleForm.rewardMode === 'fixed' && ruleForm.distributionType == 'group'">
            <el-table
              :data="ruleForm.ruleRelModelList"
              style="width: 100%"
              ref="table"
              stripe
              size="small"
              :show-header="showHeader"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="每组件数"
                prop="rewardNumberLimit"
                width="400"
              >
                <template slot-scope="scope">
                  参与该活动的商品每满
                  <el-input
                    type="text"
                    maxlength="8"
                    @blur="debouncedFilterGt0OrListFixed0(scope.$index, 'rewardNumberLimit')"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardNumberLimit"
                    clearable
                    placeholder=""
                    size="small"
                  ></el-input>
                  件为一组
                  <span
                    @click="refreshQuantity(scope.row, scope.$index)"
                    style="
                      margin-left: 30px;
                      padding: 0 10px;
                      color: #e50065;
                      cursor: pointer;
                      font-size: 16px;
                    "
                    ><i class="el-icon-bottom"></i
                  ></span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="每组额外奖励"
                prop="rewardValue"
                width="300"
              >
                <template slot-scope="scope">
                  每组奖励
                  <el-input
                    type="text"
                    maxlength="8"
                   :class="{'error': !scope.row.rewardValue}"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardValue"
                    @input="filterGt0OrListFixed2(scope.$index, 'rewardValue')"
                    clearable
                    placeholder=""
                    size="small"
                  ></el-input>
                  元
                  <span
                    @click="refreshMoney(scope.row, scope.$index)"
                    style="
                      margin-left: 30px;
                      padding: 0 10px;
                      color: #e50065;
                      cursor: pointer;
                      font-size: 16px;
                    "
                    ><i class="el-icon-bottom"></i
                  ></span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.$index !== 0"
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div
              @click="addChild()"
              style="
                border-bottom: 1px solid #ebeef5;
                display: flex;
                justify-content: center;
                padding: 10px 0;
                cursor: pointer;
              "
            >
              <el-button size="small" type="text">新 增 </el-button>
            </div>
          </div>
          <!-- 按件奖励 -->
          <div class="table" v-if="ruleForm.rewardMode === 'fixed' && ruleForm.distributionType == 'item'">
            <el-table
              :data="ruleForm.ruleRelModelList"
              style="width: 100%"
              ref="table"
              stripe
              size="small"
              :show-header="showHeader"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="数量"
                prop="rewardNumberLimit"
                width="250"
              >
                <template slot-scope="scope">
                  当数量大于等于
                  <el-input
                    type="text"
                    maxlength="8"
                    @blur="debouncedFilterGt0OrListFixed0(scope.$index, 'rewardNumberLimit')"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardNumberLimit"
                    clearable
                    placeholder=""
                    size="small"
                  ></el-input>
                  件时，
                  <!-- <span
                    @click="refreshQuantity(scope.row, scope.$index)"
                    style="
                      margin-left: 30px;
                      padding: 0 10px;
                      color: #e50065;
                      cursor: pointer;
                      font-size: 16px;
                    "
                    ><i class="el-icon-bottom"></i
                  ></span> -->
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="金额"
                prop="rewardValue"
                width="220"
              >
                <template slot-scope="scope">
                  每件按
                  <el-input
                    type="text"
                    maxlength="8"
                   :class="{'error': !scope.row.rewardValue}"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardValue"
                    @input="filterGt0OrListFixed2(scope.$index, 'rewardValue')"
                    clearable
                    placeholder=""
                    size="small"
                  ></el-input>
                  元发放
                  <!-- <span
                    @click="refreshMoney(scope.row, scope.$index)"
                    style="
                      margin-left: 30px;
                      padding: 0 10px;
                      color: #e50065;
                      cursor: pointer;
                      font-size: 16px;
                    "
                    ><i class="el-icon-bottom"></i
                  ></span> -->
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.$index !== 0"
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
             <el-form-item style="margin-top:10px" label="奖励上限(元)" prop="maxDistributionAmount" v-if="ruleForm.distributionType == 'item'">
              <el-input
                  type="text"
                  maxlength="8"
                  @mousewheel.prevent.native
                  style="width: 240px"
                  v-model.trim="ruleForm.maxDistributionAmount"
                  @input="filterMaxDistributionAmount"
                  clearable
                  placeholder="请输入上限奖励"
                  size="small"
                ></el-input>
             </el-form-item>
            <div
              @click="addChild()"
              style="
                border-bottom: 1px solid #ebeef5;
                display: flex;
                justify-content: center;
                padding: 10px 0;
                cursor: pointer;
              "
            >
              <el-button size="small" type="text">新 增 </el-button>
            </div>
          </div>
          
          <div class="table" v-if="ruleForm.rewardMode === 'sub' || ruleForm.rewardMode === 'tiktokLikePas'"
          >
            <div>
              <el-button size="small" @click="addChildSub" type="text"
                >添加阶梯奖励
              </el-button>
            </div>
            <el-table
              v-if="ruleForm.ruleRelModelList.length"
              :data="ruleForm.ruleRelModelList"
              style="width: 100%"
              ref="table"
              stripe
              size="small"
              :show-header="showHeader"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="start"
                label="每组件数"
                width="700"
                prop="rewardNumberLimit"
              >
                <template slot-scope="scope">
                  买
                  <el-input
                    type="text"
                    maxlength="8"
                    @blur="filterGt0OrListFixed0(scope.$index, 'rewardNumberLimit')"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardNumberLimit"
                    clearable
                    placeholder=""
                    size="small"
                  ></el-input>
                  件, 送
                  <el-input
                    type="text"
                    maxlength="8"
                    @input="filterGt0OrListFixed2(scope.$index, 'rewardSubNum')"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardSubNum"
                    clearable
                    placeholder=""
                    size="small"
                  ></el-input>
                  件,{{
                    new Number(scope.row.rewardNumberLimit) +
                    new Number(scope.row.rewardSubNum)
                  }}件为一组，发放{{
                    new Number(scope.row.rewardNumberLimit)
                  }}件商品的单件奖励, 每组额外奖励
                  <el-input
                    type="text"
                    maxlength="8"
                    @input="filterGt0OrListFixed2(scope.$index, 'rewardValue')"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardValue"
                    clearable
                    placeholder=""
                    size="small"
                  ></el-input>
                  元
                </template>
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="table" v-if="ruleForm.rewardMode === 'radio'">
            <el-table
              :data="ruleForm.ruleRelModelList"
              style="width: 100%"
              ref="table"
              stripe
              border
              size="small"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="冲刺门槛"
                prop="rewardNumberLimit"
              >
                <template slot-scope="scope">
                  <el-input
                    type="text"
                    maxlength="8"
                     @blur="filterGt0OrListFixed0(scope.$index, 'rewardNumberLimit')"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardNumberLimit"
                    clearable
                    placeholder=""
                    size="small"
                  ></el-input>
                  件
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="额外奖励"
                prop="rewardValue"
              >
                <template slot-scope="scope">
                  每件额外奖励
                  <el-input
                    type="text"
                    maxlength="8"
                    @input="filterGt0OrListFixed2(scope.$index, 'rewardValue')"
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardValue"
                    clearable
                    placeholder=""
                    size="small"
                  ></el-input>
                  元
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.$index === 0"
                      size="small"
                      @click="addChild(scope.$index)"
                      type="text"
                      >新 增
                    </el-button>
                    <el-button
                      v-else
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>

        <!-- 新功能 -->
        <el-form-item label="超出上限设置" v-if="ruleForm.rewardMode === 'fixed'&& ruleForm.distributionType == 'group'">
          <el-switch v-model.number="ruleForm.upperLimitSwitch" active-color="#13ce66" @change="upperLimitSwitchChange"></el-switch>
          <p  class="exceeding-upper-limit-setting">以您设定的最高一层奖励金额为上限 （最高奖励）</p>
        </el-form-item>
        <el-form-item label="适配商户类型" prop="adapterStoreType">
          <el-radio-group v-model="ruleForm.adapterStoreType">
            <el-radio :label="'norm'">普通</el-radio>
            <el-radio :label="'month'">月结</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动时段" prop="validatorTime" ref="validatorTime">
          <hm-date-select
            title="活动"
            :isShow="isShow"
            :datePicker="datePicker"
            @swithRunningTimeType="swithRunningTimeType"
            ref="hmDateSelect"
            multipleTime
          ></hm-date-select>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.rewardMode === 'fixed' && ruleForm.distributionType == 'group'"
          label="必有商品"
          ref="requiredGoodsMode"
        >
          <el-switch
            v-model="ruleForm.requiredGoodsMode"
            active-text="开启"
            inactive-text="关闭"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="活动下线" prop="autoOfflineDaysLimt">
          到期
          <el-input
            type="text"
            maxlength="8"
            @input="filterGt0OrFixed0('autoOfflineDaysLimt')"
            @mousewheel.prevent.native
            style="width: 100px"
            v-model.trim="ruleForm.autoOfflineDaysLimt"
            clearable
            placeholder=""
            size="small"
          ></el-input>
          天后自动下线。
        </el-form-item>
        <el-form-item label="活动备注" prop="rewardRemark">
          <el-input
            type="textarea"
            v-model.trim="ruleForm.rewardRemark"
            clearable
            :rows="6"
            placeholder="请输入活动备注"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 第二步 -->
      <div v-show="step === 2">
        <div class="mb10">
          适配组织
          <el-cascader
            clearable
            @change="changgeaa"
            filterable
            style="width: 600px"
            class="mr10 applDepart"
            ref="cascader"
            v-model="ruleForm.applDepartId"
            :props="props"
            :options="cascaderList"
            :show-all-levels="false"
            size="small"
            placeholder="请选择机构"
          ></el-cascader>
        </div>

        <div class="flex flex-between mb10">
          <div>
            <el-button
              type="primary"
              plain
              size="small"
              :disabled="!ruleForm.applDepartId.length"
              @click="merchantDialogVisible = true"
              >+
              {{
                ruleForm.adapterStoreType == "month"
                  ? "添加月结商户"
                  : "添加商户"
              }}
            </el-button>
            <el-input
              v-model="shopSearchVal"
              size="small"
              class="ml10"
              clearable
              placeholder="输入商户名称搜索"
               @input = "getShopSearchVal"
              @clear = "clearShopSearchVal"
            />
          </div>
          <div>
            <el-button @click="output" type="primary" size="small"
              >导出模板
            </el-button>
            <el-button
              v-if="!ruleForm.applDepartId.length"
              type="info"
              size="small"
              disabled
              >导入表格
            </el-button>
            <el-button
              v-else
              type="primary"
              size="small"
              class="open-file pointer"
              >导入表格
              <input
                type="file"
                class="pointer"
                @change="importfs"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </el-button>
            <el-button
              :disabled="!shopList.length"
              type="primary"
              size="small"
              class="open-file pointer"
              >导入删除商户表格
              <input
               :disabled="!shopList.length"
                type="file"
                class="pointer"
                @change="importfDelete"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </el-button>
            <el-button @click="batchRemoveShops" type="primary" size="small"
              >批量删除
            </el-button>
            <el-button @click="allBatchRemoveShops" type="primary" size="small"
              >全部删除
            </el-button>
            <!-- <span @click="batchRemoveShops" class="pointer ml10">
              <span class="delete-icon hmicon icon-shanchu"></span>批量删除
            </span> -->
             <!-- <span @click="allBatchRemoveShops" class="pointer ml10">
              <span class="delete-icon hmicon icon-shanchu"></span>全部删除
            </span> -->
          </div>
        </div>
        <div class="table mb10">
          <el-table
            stripe
            ref="shopRoleTable"
            height="400px"
            :data="
              shopListNew.filter(
                (data) =>
                  !shopSearchVal ||
                  data.storeName
                    .toLowerCase()
                    .includes(shopSearchVal.toLowerCase())
              )
            "
            style="width: 100%"
            id="table"
            size="small"
            @row-click="
              (row, column, e) => tableSelect(row, column, e, 'shopRoleTable')
            "
            border
            @selection-change="getShopBatchChecked"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="商户名称"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="180px"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-tooltip class="item" content="删除" placement="top">
                    <div class="pointer mr10" @click="remove(scope.row)">
                      <span class="hmicon icon-shanchu primary"></span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
           <div
            class="hm-pagination"
            v-if="shopListNew && shopListNew.length > 0 && !shopSearchVal"
          >
            <el-pagination
              background
              :total="selfCreatedShopListPageTotal"
              @current-change="createShopListPaginationPaging"
              @size-change="selfCreatedHandleSizeShopListChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="selfCreatedCurrentShopListPage"
               :page-size="selfCreatedPageShopListSize"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 第三步 -->
      <div v-show="step === 3">
        <div class="flex flex-between item-center mb10">
          <div>
            <el-button type="primary" size="small" @click="addGoods"
              >添加商品
            </el-button>
            <el-input
              v-model="goodSearchVal"
              size="small"
              class="ml10"
              clearable
              style="width: 180px"
              placeholder="输入商品名称/条码搜索"
              @input = "getGoodSearchVal"
              @clear = "clearGoodSearchVal"
            />
          </div>
          <div class="flex flex-end item-center" style="marginbottom: -20px">
            <div @click="outputExcel" class="delete mr20 pointer">
              <span class="delete-icon hmicon icon-daochu"></span>
              导出模板
            </div>
            <div @click="step3Products" class="delete mr20 pointer open-file">
              <span class="delete-icon hmicon icon-daoru"></span>
              导入商品
              <!-- <input type="file" @change="importf"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" /> -->
            </div>
            <el-button type="text" size="small" @click="batchRemove"
              >批量删除
            </el-button>
            <el-button type="text" size="small" @click="allRemove"
              >全部删除
            </el-button>
          </div>
        </div>
        <div class="table mb10">
          <!-- 3、列表 本地导入 -->
      <el-table
            stripe
            ref="goodRoleTable"
            :data="
              addGoodsListNew.filter(
                (data) =>
                  !goodSearchVal ||
                  data.goodsName
                    .toLowerCase()
                    .includes(goodSearchVal.toLowerCase()) ||
                  data.goodsBarcode
                    .toLowerCase()
                    .includes(goodSearchVal.toLowerCase())
              )
            "
            style="width: 100%"
            id="table"
            size="small"
            @row-click="
              (row, column, e) => tableSelect(row, column, e, 'goodRoleTable')
            "
            max-height="500px"
            border
            @selection-change="getBatchChecked"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="商品品牌"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsBarcode"
              label="商品条码"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="rewardBaseMoney"
              label="单件奖励"
              v-if="
                ruleForm.rewardMode === 'sub' ||
                ruleForm.rewardMode === 'tiktokLikePas'
              "
            >
              <template slot-scope="scope">
                <el-input
                  type="text"
                  maxlength="8"
                  @input="
                    filterGt0OrGoodsListFixed2(scope.$index, 'rewardBaseMoney')
                  "
                  @mousewheel.prevent.native
                  style="width: 100px"
                  v-model.trim="scope.row.rewardBaseMoney"
                  clearable
                  placeholder=""
                  size="small"
                ></el-input>
                元
              </template>
            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-tooltip class="item" content="删除" placement="top">
                    <div class="pointer mr10" @click="removeGoods(scope.row)">
                      <span class="hmicon icon-shanchu primary"></span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div
            class="hm-pagination"
            v-if="addGoodsListNew && addGoodsListNew.length > 0 && !goodSearchVal"
          >
            <el-pagination
              background
              :total="selfCreatedPageTotal"
              @current-change="createYourOwnPaginationPaging"
              @size-change="selfCreatedHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="selfCreatedCurrentPage"
               :page-size="selfCreatedPageSize"
            ></el-pagination>
          </div>
        </div>
      </div>

      <!-- 第四步 -->
      <div
        v-show="step === stepsComputed.length - 1 && ruleForm.requiredGoodsMode"
      >
        <div
          class="head"
          style="padding-left: 20px"
          v-if="ruleForm.rewardMode === 'fixed'"
        >
          <div
            class="lis"
            v-for="(v, index) in ruleForm.ruleRelModelList"
            :key="index"
          >
            <p style="width: 50px; text-align: center">{{ index + 1 }}</p>
            参与活动的商品每满<el-input
              v-model="v.rewardNumberLimit"
              disabled
              size="mini"
              style="width: 60px; margin: 0 10px"
            ></el-input
            >件为一组 每组奖励<el-input
              v-model="v.rewardValue"
              disabled
              size="mini"
              style="width: 60px; margin: 0 10px"
            ></el-input
            >元 限制数量<el-input
              :min="0"
              v-model="v.rewardRequiredNum"
              @change="
                limitInput(v.rewardRequiredNum, v.rewardNumberLimit, index)
              "
              size="mini"
              style="width: 60px; margin: 0 10px"
            ></el-input
            >件
          </div>
        </div>
        <div class="table mb10">
          <hm-base-transfer-new
            ref="providerTransfer"
            leftName="选择商品"
            rightName="选择商品"
            :leftOption="leftOption3"
            :rightOption="rightOption3"
            compareKey="supplierGoodsId"
            @getTransferResult="getTransferResult3"
          ></hm-base-transfer-new>
        </div>
      </div>

      <!-- 第五步 -->
      <div v-show="step === stepsComputed.length">
        <div class="flex flex-between mb10">
          <!-- <div class="flex-1">活动名称：
            <span>{{ ruleForm.rewardName }}</span>            
          </div> -->
          <div class="flex-1 flex">
            活动名称：
            <div class="flex-1" @dblclick="changeRewardName()">
              <span v-show="edit_rewardName">
                {{ ruleForm.rewardName }}
              </span>
              <el-input
                ref="rewardNameinput"
                @blur="rewardNameblur()"
                @keyup.enter.native="$event.target.blur"
                clearable
                v-show="!edit_rewardName"
                size="small"
                style="width: 260px"
                v-model="ruleForm.rewardName"
                placeholder="请输入活动名称"
              ></el-input>
            </div>
          </div>
          <div class="flex-1" v-if="ruleForm.rewardMode === 'fixed'">
            活动类型：普通活动
          </div>
          <div class="flex-1" v-if="ruleForm.rewardMode === 'sub'">
            活动类型：差异活动
          </div>
          <div class="flex-1" v-if="ruleForm.rewardMode === 'tiktokLikePas'">
            活动类型：报名活动
          </div>
          <div class="flex-1" v-if="ruleForm.rewardMode === 'radio'">
            活动类型：冲刺活动
          </div>
          <div class="flex-1">
            活动下线：到期<span class="blue">{{
              ruleForm.autoOfflineDaysLimt
            }}</span
            >天后自动下线
          </div>
          <div class="flex-1 flex flex-wrap">
            <div>适用时段：</div>

            <div
              class="flex flex-center blue"
              v-if="ruleForm.dateConfigMode === 'general'"
            >
              {{ ruleForm.rewardStartDate }}至{{ ruleForm.rewardEndDate }}
            </div>
            <div
              class="flex flex-center blue"
              v-if="ruleForm.dateConfigMode === 'special'"
            >
              <div v-if="ruleForm.dateType === 'date'">
                {{ ruleForm.rewardStartDate }}至{{
                  ruleForm.rewardEndDate
                }}的每{{ ruleForm.dateValue }}天
              </div>
              <div v-if="ruleForm.dateType === 'week'">
                {{ ruleForm.rewardStartDate }}至{{ ruleForm.rewardEndDate }}的
                <span v-for="(v, i) in ruleForm.dateValue" :key="i">
                  {{ i === 0 ? "" : "," }}每周{{ v }}</span
                >
              </div>
              <div v-if="ruleForm.dateType === 'month'">
                {{ ruleForm.rewardStartDate }}至{{ ruleForm.rewardEndDate }}的
                <span v-for="(v, i) in ruleForm.dateValue" :key="i">
                  {{ i === 0 ? "" : "," }}每月{{ v }}号</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-between mb10">
          <div class="flex-1">
            适配组织：<span
              v-for="(v, i) in ruleForm.applyDepartNames"
              :key="i"
            >
              {{ i === 0 ? "" : "," }}{{ v }}</span
            >
          </div>
          <div class="flex-1 flex-wrap">
            活动备注：{{ ruleForm.rewardRemark }}
          </div>
        </div>

        <div class="title mb10">
          适用商户:
          <span class="blue" v-for="(v, i) in shopList" :key="i">
            {{ i === 0 ? "" : "," }}{{ v.storeName }}</span
          >
        </div>
        <div class="flex" v-if="ruleForm.rewardMode === 'tiktokLikePas'">
            <div class="flex-1 title mb10">表单关联：</div>
            <div class="flex-1" >
              <el-button type="primary" size="small"
                @click="hmFormDisabled = false, formDialogVisible = true">关联表单</el-button>
            </div>
        </div>
        <div v-if="ruleForm.rewardMode === 'tiktokLikePas'">
          <div class="title mb10">图文详情：</div>
          <div style="color: red; font-weight: bold">
            详情内若有图片，请上传图片，不要直接复制或者拖拽图片，这样有可能导致手机端图文无法正常显示
          </div>
          <hm-rich-editor v-if="dialogVisible" v-model="ruleForm.actDesc" />
        </div>

        <div class="flex-1" v-if="ruleForm.rewardMode === 'tiktokLikePas'">
          <div>主图：</div>
          <my-upload
            field="file"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="show"
            noCircle
            noSquare
            :width="750"
            :height="600"
            :headers="{ 'X-Access-Token': $token }"
            :params="{ fileDir: 'mall' }"
            :url="$uploadUrl"
            img-format="png"
          ></my-upload>
          <el-button
            type="primary"
            size="small"
            v-show="!listHeaderImgUrl"
            @click="toggleShow"
            >上传</el-button
          >
          <span class="form-tip"
            >（主图仅可设置一张，图片尺寸建议750x600）</span
          >
          <div class="priview" v-if="listHeaderImgUrl">
            <img :src="listHeaderImgUrl" alt="主图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div>
          </div>
        </div>
        <div class="title mb10">
          活动规则:
          <span v-if="ruleForm.rewardMode === 'fixed'">普通活动
             <span v-if="ruleForm.distributionType == 'group'">(按组奖励)</span>
            <span v-if="ruleForm.distributionType == 'item'">(按件奖励)</span>
          </span>
          <span v-else-if="ruleForm.rewardMode === 'sub'">差异活动</span>
          <span v-else-if="ruleForm.rewardMode === 'tiktokLikePas'"
            >报名活动</span
          >
          <span v-else-if="ruleForm.rewardMode === 'radio'">冲刺活动</span>
          <p
            v-if="ruleForm.rewardMode === 'fixed' && ruleForm.upperLimitSwitch"
            class="rule-upperLimitSwitch"
          >
            <span>根据申报数量按照规则门槛匹配一次，当前活动最高奖励</span>
            <span class="money">{{
              ruleForm.ruleRelModelList[ruleForm.ruleRelModelList.length - 1][
                "rewardValue"
              ]
            }}</span>
            <span>元</span>
          </p>
        </div>
        <div v-if="ruleForm.rewardMode === 'fixed' && ruleForm.distributionType == 'item'">按件奖励规则：以申报件数匹配最高等级X单件金额</div>
        <div class="table mb10" v-if="ruleForm.rewardMode === 'fixed' && ruleForm.distributionType == 'group'">
          <el-table
            stripe
            ref="roleTable"
            :data="ruleForm.ruleRelModelList"
            style="width: 500px"
            border
            id="table"
            max-height="500px"
            size="small"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="每组件数"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                每满{{ scope.row.rewardNumberLimit }}件为一组
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="每组额外奖励"
              prop="rewardValue"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardValue }}元
              </template>
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              label="限制数量"
              v-if="
                ruleForm.requiredGoodsMode ||
                ruleForm.requiredGoodsMode == 'yes'
              "
              prop="rewardRequiredNum"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardRequiredNum }}件
              </template>
            </el-table-column>
          </el-table>
        </div>
         <div class="table mb10" v-if="ruleForm.rewardMode === 'fixed' && ruleForm.distributionType == 'item'">
          <el-table
            stripe
            ref="roleTable"
            :data="ruleForm.ruleRelModelList"
            style="width: 500px"
            border
            id="table"
            max-height="500px"
            size="small"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="数量"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                当数量大于等于{{ scope.row.rewardNumberLimit }}件时
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="每件奖励"
              prop="rewardValue"
            >
              <template slot-scope="scope">
                每件按{{ scope.row.rewardValue }}元发放
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex-1 flex item-center" v-if="ruleForm.rewardMode === 'fixed' && ruleForm.distributionType == 'item'">
            奖励上限(元)
              <el-input
                readonly
                size="small"
                style="width: 180px;margin-left:10px"
                v-model="ruleForm.maxDistributionAmount"
              ></el-input>
             <!-- <span >
                {{ ruleForm.maxDistributionAmount }}
              </span> -->
            <!-- <div class="flex-1" @dblclick="changeRewardName()">
              <span v-show="edit_rewardName">
                {{ ruleForm.rewardName }}
              </span>
              <el-input
                ref="rewardNameinput"
                @blur="rewardNameblur()"
                @keyup.enter.native="$event.target.blur"
                clearable
                v-show="!edit_rewardName"
                size="small"
                style="width: 260px"
                v-model="ruleForm.rewardName"
                placeholder="请输入活动名称"
              ></el-input>
            </div> -->
          </div>
        <div class="table mb10"  v-if=" ruleForm.rewardMode === 'sub' || ruleForm.rewardMode === 'tiktokLikePas'
          "
        >
          <el-table
            :data="ruleForm.ruleRelModelList"
            style="width: 100%"
            ref="table"
            stripe
            max-height="500px"
            size="small"
            :show-header="showHeader"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="start"
              label="每组件数"
              width="700"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                买
                {{ scope.row.rewardNumberLimit }}
                件, 送
                {{ scope.row.rewardSubNum }}
                件,X{{
                  new Number(scope.row.rewardNumberLimit) +
                  new Number(scope.row.rewardSubNum)
                }}件为一组，发放
                {{ scope.row.rewardNumberLimit }}件商品的单件奖励, 每组额外奖励
                {{ scope.row.rewardValue }}
                元
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table mb10" v-if="ruleForm.rewardMode === 'radio'">
          <el-table
            stripe
            ref="roleTable"
            :data="ruleForm.ruleRelModelList"
            style="width: 500px"
            border
            id="table"
            size="small"
            max-height="500px"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="冲刺门槛"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardNumberLimit }}件
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="额外奖励"
              prop="rewardValue"
            >
              <template slot-scope="scope">
                每件额外奖励{{ scope.row.rewardValue }}元
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="title mb10">适用商品</div>
        <div class="table mb10">
          <el-table
            ref="roleTable"
            :data="addGoodsListNew"
            style="width: 100%"
            :row-class-name="addGoodsListRCN"
            id="table"
            size="small"
            border
            max-height="500px"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="商品品牌"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsBarcode"
              label="商品条码"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="rewardBaseMoney"
              label="单件奖励"
              v-if="
                ruleForm.rewardMode === 'sub' ||
                ruleForm.rewardMode === 'tiktokLikePas'
              "
            >
            </el-table-column>
          </el-table>

          <div
            class="hm-pagination"
            v-if="addGoodsListNew && addGoodsListNew.length > 0"
          >
            <el-pagination
              background
              :total="selfCreatedPageTotal"
              @current-change="createYourOwnPaginationPaging"
              @size-change="selfCreatedHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="selfCreatedCurrentPage"
               :page-size="selfCreatedPageSize"
            ></el-pagination>
          </div>
        </div>
      </div>

      <div class="btn-wrapper flex flex-center">
        <!-- <el-button size="small" @click="dialogVisible = false">取 消</el-button> -->
        <el-button
          size="small"
          type="primary"
          v-if="step > 1"
          @click="step = step - 1"
          >上一步
        </el-button>
        <el-button
          size="small"
          type="primary"
          v-if="step < stepsComputed.length"
          @click="submitRuleForm('ruleForm')"
          >下一步
        </el-button>
        <el-button
          size="small"
          type="primary"
          v-if="step === stepsComputed.length"
          @click="submitRuleForm('ruleForm')"
          >保存
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加商户"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="merchantDialogVisible"
    >
      <div class="form-tip mb20">
        使用<span style="font-weigth: bold; font-size: 16px; color: #e50065"
          >ctrl+f</span
        >
        可搜索商户名
      </div>
      <div class="mb20">
        <el-table
          stripe
          border
          height="400"
          ref="addBrandTable"
          @row-click="
            (row, column, e) => tableSelect(row, column, e, 'addBrandTable')
          "
          @selection-change="getMerchantChecked"
          :data="
            departBindingStoreBox.filter(
              (item) =>
                !merchantName ||
                item.storeName
                  .toLowerCase()
                  .includes(merchantName.toLowerCase())
            )
          "
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商户"
            prop="storeName"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-center">
        <el-button size="small" type="primary" @click="addShop"
          >确 定
        </el-button>
        <el-button size="small" @click="merchantDialogVisible = false"
          >取 消
        </el-button>
      </div>
    </el-dialog>
     <el-dialog
      title="提示"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="shopDeletedDialogVisible"
      :before-close="shopDeletedDialogClose"
    >
      <div class="form-tip mb20">
        以下商户<span style="font-weigth: bold; font-size: 16px; color: #e50065"
          >已取消关联或者已删除</span
        >
      </div>
      <div class="mb20">
        <el-table
          stripe
          border
          height="400"
          ref="addBrandTable"
          :data="shopDeletedList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="商户"
            prop="storeName"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-center">
        <el-button size="small" type="primary" @click="shopDeletedDialogClose"
          >确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加商品"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoods"
    >
      <div class="table-panel flex flex-end">
        <div class="flex align-center">
          <div @click="outputGoodsExcel" class="delete mr20 pointer">
            <span class="delete-icon hmicon icon-daochu"></span>
            导出模板
          </div>
          <div class="delete mr20 pointer open-file">
            <span class="delete-icon hmicon icon-daoru"></span>
            导入商品
            <input
              type="file"
              @change="importGoodsF"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <el-input
            clearable
            style="width: 200px"
            v-model.trim="searchDialogCondition.keyWords"
            placeholder="请输入商品名称/条码"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-select
            clearable
            size="small"
            class="mr10"
            filterable
            v-model="searchDialogCondition.hemiaoBrandId"
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>

          <el-button type="primary" size="small" @click="searchGoods"
            >查询
          </el-button>
          <el-button size="small" type="text" @click="newGood()"
            >新增商品
          </el-button>
        </div>
      </div>
      <!-- <div class="flex flex-start mb10">
        <div>
          添加商品
          <el-input
            clearable
            style="width:200px;"
            v-model.trim="addGood.goodsName"
            placeholder="请输入商品名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-input
            clearable
            style="width:200px;"
            v-model.trim="addGood.goodsBarcode"
            placeholder="请输入商品条码"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-select
            clearable
            size="small"
            class="mr10"
            v-model="addGood.hemiaoBrandId"
            filterable
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>
          <el-button
            type="primary"
            plain
            size="small"
            :disabled="
              addGood.goodsName === '' ||
                addGood.goodsBarcode === '' ||
                addGood.hemiaoBrandId === ''
            "
            @click="addMerchandise"
            >+ 添加</el-button
          >
        </div>
      </div> -->
      <div class="table">
        <el-table
          stripe
          ref="addGoodTable"
          :data="supplierGoodsInfoList.records"
          @row-click="
            (row, column, e) => tableSelect(row, column, e, 'addGoodTable')
          "
          @selection-change="getChecked"
          style="width: 100%"
          id="table"
          size="small"
          border
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="
              (index) => index + (currentMicroPage - 1) * pageMicroSize + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="商品添加时间"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="supplierGoodsInfoList.total"
            @current-change="pagingMicro"
            @size-change="handleSizeMicroChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentMicroPage"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <el-button type="primary" size="small" @click="affirm">确认</el-button>
        <el-button size="small" @click="dialogVisibleGoods = false"
          >取消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="活动详情"
      width="80%"
      :close-on-click-modal="false"
      :visible.sync="detailsDialogVisible"
      @close="handleDetailDialogClose"
    >
      <div class="flex flex-between mb10">
        <div class="flex-1">
          活动名称：{{ detailsSupplierBasicInfo.ruleInfo.rewardName }}
        </div>
        <div class="flex-1">
          活动下线：到期<span class="blue">{{
            detailsSupplierBasicInfo.ruleInfo.autoOfflineDaysLimt
          }}</span
          >天后自动下线
        </div>
        <div class="flex-1 flex flex-wrap">
          <div>适用时段：</div>

          <div
            class="flex flex-center blue"
            v-if="
              detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'general'
            "
          >
            {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
              detailsSupplierBasicInfo.ruleInfo.rewardEndDate
            }}
          </div>
          <div
            class="flex flex-center blue"
            v-if="
              detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'special'
            "
          >
            <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'date'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}的每{{ detailsSupplierBasicInfo.ruleInfo.dateValue }}天
            </div>
            <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'week'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}的
              <span
                v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                :key="i"
              >
                {{ i === 0 ? "" : "," }}每周{{ v }}</span
              >
            </div>
            <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'month'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}的
              <span
                v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                :key="i"
              >
                {{ i === 0 ? "" : "," }}每月{{ v }}号</span
              >
            </div>
          </div>
        </div>
        <!-- <div class="flex-1">
          基础提成：
          <span
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
            class="primary"
          >
            ¥{{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}</span
          >
          <span v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'">
            {{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}%</span
          >
        </div>
        <div class="flex-1">
          活动条件：参与该活动的商品每满
          <span class="blue">{{
            detailsSupplierBasicInfo.ruleInfo.rewardNumberLimit
          }}</span>
          件为一组计算活动
        </div> -->
      </div>
      <div class="flex flex-between mb10">
        <div class="flex-1">
          适配组织：{{ detailsSupplierBasicInfo.ruleInfo.departNames }}
        </div>
        <div class="flex-1 flex-wrap">
          活动备注：{{ detailsSupplierBasicInfo.ruleInfo.rewardRemark }}
        </div>
      </div>

      <div class="title mb10">
        适用商户:
        <span
          class="blue"
          v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
          :key="i"
        >
          {{ i === 0 ? "" : "," }}{{ v }}</span
        >
      </div>

      <div class="title mb10">
        适配商户类型：{{
          detailsSupplierBasicInfo.ruleInfo.adapterStoreType == "month"
            ? "月结"
            : "普通"
        }}
      </div>
      <!-- <div class="table mb10">
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
          style="width: 100%"
          id="table"
          size="small"
          border
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="label"
            label="商户名称"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div> -->
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
      >
        活动类型：普通活动
        <span v-if="detailsSupplierBasicInfo.ruleInfo.distributionType === 'group'">(按组奖励)</span>
        <span v-if="detailsSupplierBasicInfo.ruleInfo.distributionType === 'item'">(按件奖励)</span>
      </div>
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
      >
        活动类型：差异活动
      </div>
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'tiktokLikePas'"
      >
        活动类型：报名活动
      </div>
      <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
      >
        活动类型：冲刺活动
      </div>
      <div
        class="mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'tiktokLikePas'"
      >
        <el-button
          type="primary"
          size="small"
          @click="(hmFormDisabled = true), (formDialogVisible = true)"
          >关联表单</el-button
        >
      </div>
      <div
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'tiktokLikePas'"
      >
        <div class="title mb10">图文详情：</div>
        <div style="color: red; font-weight: bold">
          详情内若有图片，请上传图片，不要直接复制或者拖拽图片，这样有可能导致手机端图文无法正常显示
        </div>
        <hm-rich-editor
          v-if="dialogVisible || detailsDialogVisible"
          v-model="ruleForm.actDesc"
        />
      </div>
      <div
        class="priview"
        v-if="
          listHeaderImgUrl &&
          detailsSupplierBasicInfo.ruleInfo.rewardMode === 'tiktokLikePas'
        "
      >
        <img :src="listHeaderImgUrl" alt="主图" />
        <!-- <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div> -->
      </div>
      <div class="title mb10">
        <span>活动规则：</span>
        <p
          v-if="
            detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' &&
            detailsSupplierBasicInfo.ruleInfo.upperLimitSwitch
          "
          class="rule-upperLimitSwitch"
          style="margin: 0"
        >
          <span>根据申报数量按照规则门槛匹配一次，当前活动最高奖励</span>
          <span class="money">{{
            detailsSupplierBasicInfo.ruleInfo.ruleRelModelList[
              detailsSupplierBasicInfo.ruleInfo.ruleRelModelList.length - 1
            ]["rewardValue"]
          }}</span>
          <span>元</span>
        </p>
      </div>
      <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' && detailsSupplierBasicInfo.ruleInfo.distributionType === 'group'"
      >
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 500px"
          border
          id="table"
          size="small"
          max-height="500px"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="每组件数"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              每满{{ scope.row.rewardNumberLimit }}件为一组
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="每组额外奖励"
            prop="rewardValue"
          >
            <template slot-scope="scope">
              {{ scope.row.rewardValue }}元
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            v-if="
              detailsSupplierBasicInfo.ruleInfo.requiredGoodsMode == 'true' ||
              detailsSupplierBasicInfo.ruleInfo.requiredGoodsMode == 'yes'
            "
            label="限制数量"
            prop="rewardRequiredNum"
          >
            <template slot-scope="scope">
              {{ scope.row.rewardRequiredNum }}件
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' && detailsSupplierBasicInfo.ruleInfo.distributionType == 'item'">按件奖励规则：以申报件数匹配最高等级X单件金额</div>
        <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' && detailsSupplierBasicInfo.ruleInfo.distributionType === 'item'"
      >
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 500px"
          border
          id="table"
          size="small"
          max-height="500px"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="数量"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              当数量大于等于{{ scope.row.rewardNumberLimit }}件时
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="每件奖励"
            prop="rewardValue"
          >
            <template slot-scope="scope">
             每件按{{ scope.row.rewardValue }}元发放
            </template>
          </el-table-column>
        </el-table>
         <div class="flex-1 flex item-center mt10" v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' && detailsSupplierBasicInfo.ruleInfo.distributionType === 'item'">
            奖励上限(元)
              <el-input
                readonly
                size="small"
                style="width: 180px;margin-left:10px"
                v-model="detailsSupplierBasicInfo.ruleInfo.maxDistributionAmount"
              ></el-input>
          </div>
      </div>
      <div
        class="table mb10"
        v-if="
          detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub' ||
          detailsSupplierBasicInfo.ruleInfo.rewardMode === 'tiktokLikePas'
        "
      >
        <el-table
          stripe
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 100%"
          ref="table"
          size="small"
          :show-header="showHeader"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="start"
            label="每组件数"
            width="700"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              买
              {{ scope.row.rewardNumberLimit }}
              件, 送
              {{ scope.row.rewardSubNum }}
              件,{{
                new Number(scope.row.rewardNumberLimit) +
                new Number(scope.row.rewardSubNum)
              }}件为一组，发放
              {{ scope.row.rewardNumberLimit }}件商品的单件奖励, 每组额外奖励
              {{ scope.row.rewardValue }}
              元
            </template>
          </el-table-column>

          <!-- <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.$index === 0"
                      size="small"
                      @click="addChild(scope.$index)"
                      type="text"
                      >新 增</el-button
                    >
                    <el-button
                      v-else
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除</el-button
                    >
                  </div>
                </template>
              </el-table-column> -->
        </el-table>
      </div>
      <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
      >
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 500px"
          border
          id="table"
          size="small"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="冲刺门槛"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              {{ scope.row.rewardNumberLimit }}件
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="额外奖励"
            prop="rewardValue"
          >
            <template slot-scope="scope">
              每件额外奖励{{ scope.row.rewardValue }}元
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="title mb10">适用商品</div>
      <div class="table mb10">
        <el-table
            ref="roleTable"
            :data="addGoodsListNew"
            style="width: 100%"
            id="table"
            size="small"
            max-height="500px"
            border
           :row-class-name="detailColor"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="商品品牌"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsBarcode"
              label="商品条码"
            ></el-table-column>
             <el-table-column
            header-align="center"
            align="center"
            prop="rewardBaseMoney"
            label="单件奖励"
            v-if="
              detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub' ||
              detailsSupplierBasicInfo.ruleInfo.rewardMode === 'tiktokLikePas'
            "
          >
          </el-table-column>
          </el-table>
          <div
            class="hm-pagination"
          >
            <el-pagination
              background
              :total="selfCreatedPageTotal"
              @current-change="createYourOwnPaginationPaging"
              @size-change="selfCreatedHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="selfCreatedCurrentPage"
               :page-size="selfCreatedPageSize"
            ></el-pagination>
          </div>
      </div>
      <div class="flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="handleDetailDialogClose"
        >
          确认
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="添加商品"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGood"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        ref="ruleFormGood"
        :model="ruleFormGood"
        :rules="rulesGood"
        label-width="100px"
      >
        <el-form-item label="商品名称" prop="goodsName">
          <el-input
            clearable
            v-model.trim="ruleFormGood.goodsName"
            maxlength="30"
            size="small"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品条码" prop="goodsBarcode">
          <el-input
            clearable
            v-model.trim="ruleFormGood.goodsBarcode"
            maxlength="33"
            size="small"
            placeholder="请输入商品条码"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品品牌" prop="hemiaoBrandId">
          <el-select
            clearable
            size="small"
            class="mr10"
            v-model="ruleFormGood.hemiaoBrandId"
            filterable
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in hemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleFormGood')"
          >确 定
        </el-button>
        <el-button size="small" @click="dialogVisibleGood = false"
          >取 消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errInputResult.length }}</span
            >条数据导入失败
          </div>
          <!-- <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div> -->
        </div>
        <el-table
          :data="errInputResult"
          border
          class="small-table"
          max-height="400px"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="错误商品条码"
          >
            <!-- <template slot-scope="scope"
              >{{ scope.row }}
            </template> -->
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidStore">
      <div slot="title">
        导入失败提示
        <span class="danger"
          >商户名有误、商户名重复或者商户名不属于对应供应商会导致导入失败</span
        >
      </div>
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errStoreResult.length }}</span
            >条数据导入失败
          </div>
          <!-- <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div> -->
        </div>
        <el-table
          :data="errStoreResult"
          border
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户名称"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="errValidStoreDelete">
      <div slot="title">
        删除失败提示
        <span class="danger"
          >商户名有误、商户名重复或者商户名不属于对应供应商会导致删除失败</span
        >
      </div>
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errStoreResult.length }}</span
            >条数据删除失败
            <span class="success">{{successfulDeletion}}</span>
            条数据删除成功！
          </div>
          <!-- <div>
            您有
            <span class="success"> {{ }}</span
            >条数据删除成功！
          </div> -->
        </div>
        <el-table
          :data="errStoreResult"
          border
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户名称"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title="操作日志"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleLog"
      custom-class="sales-volumn-dialog"
    >
      <div class="mb10">
        <span class="blue"> {{ row.rewardName }}</span
        >活动
      </div>
      <el-table
        :data="logList"
        style="width: 100%"
        ref="goods"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPageLog - 1) * pageSizeLog + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作人"
          prop="operatorName"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作时间"
          prop="operatorTime"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作行为"
          prop="operatorAction"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.operatorAction === 'yes'">上线</div>
            <div v-if="scope.row.operatorAction === 'no'">下线</div>
            <div v-if="scope.row.operatorAction === 'create'">创建</div>
            <div v-if="scope.row.operatorAction === 'delete'">删除</div>
            <div v-if="scope.row.operatorAction === 'changeDate'">
              修改奖励时段
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalLog"
          @current-change="pagingLog"
          @size-change="handleSizeChangeLog"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPageLog"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog
      title="修改结束时段"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleTime"
      custom-class="sales-volumn-dialog"
    >
      <div v-if="editTimeShow">
        奖励时段：
        <el-date-picker
          size="small"
          v-model="ruleDate"
          ref="datepicker"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div v-else>
        结束时间：
        <el-date-picker
          v-model="endTime"
          type="date"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          placeholder="结束时间"
          size="small"
          class="mr10"
        >
        </el-date-picker>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
        <el-button size="small" @click="dialogVisibleTime = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="批量修改结束时段"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleTimeBatch"
      custom-class="sales-volumn-dialog"
    >
      <!-- <div v-if="editTimeShow">
        奖励时段：
        <el-date-picker
          size="small"
          v-model="batchCondition.ruleDate"
          ref="datepicker"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div> -->
      <div>
        结束时间：
        <el-date-picker
          v-model="batchCondition.endTime"
          type="date"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          placeholder="结束时间"
          size="small"
          class="mr10"
        >
        </el-date-picker>
      </div>
      <div class="mt20">
        活动下线: 到期增加<el-input
          type="text"
          maxlength="8"
          @input="filterGt0OrFixed00('addDays')"
          @mousewheel.prevent.native
          style="width: 100px"
          v-model.trim="batchCondition.addDays"
          clearable
          placeholder=""
          size="small"
        ></el-input>
        <span> 天后自动下线。</span>
        <div class="form-item-tip" style="margin-left: 65px">
          只能增多天数，不能减少天数
        </div>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="batchSetting"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisibleTimeBatch = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="编辑"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :visible.sync="dialogVisibleEdit"
      custom-class="sales-volumn-dialog"
      width="1200px"
    >
      <el-form
        ref="ruleFormEdit"
        :model="ruleFormEdit"
        :rules="rulesEdit"
        label-width="100px"
      >
        <el-form-item label="活动名称:">
          <div
            class="mr20"
            style="padding-left: 20px; width: 260px"
            @dblclick="changeEnddate()"
          >
            <span v-show="edit_enddate">{{ row.rewardName }}</span>
            <el-input
              :ref="'enddateinput'"
              @blur="enddateblur()"
              @keyup.enter.native="$event.target.blur"
              clearable
              v-show="!edit_enddate"
              size="small"
              style="width: 260px"
              v-model="row.rewardName"
              placeholder="请输入活动名称"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="活动下线:" prop="autoOfflineDaysLimt">
          到期
          <!-- <el-input-number
            style="width:220px"
            v-model="ruleFormEdit.autoOfflineDaysLimt"
            controls-position="right"
            :min="numLimt"
          ></el-input-number> -->
          <el-input
            type="text"
            maxlength="8"
            @input="filterGt0OrFixed0('autoOfflineDaysLimt')"
            @mousewheel.prevent.native
            style="width: 100px"
            v-model.trim="ruleFormEdit.autoOfflineDaysLimt"
            clearable
            placeholder=""
            size="small"
          ></el-input>
          <span> 天后自动下线。</span>
          <div class="form-item-tip">只能增多天数，不能减少天数</div>
        </el-form-item>
        <el-form-item label="添加商户:" prop="value">
          <div class="mb10">
            适配组织机构：{{ applDepartNames }}
            <!-- <el-cascader
              clearable
              filterable
              style="width:600px"
              class="mr10 applDepart"
              ref="cascader"
              v-model="ruleFormEdit.applDepartId"
              :props="props"
              :show-all-levels="false"
              size="small"
              placeholder="请选择机构"
            ></el-cascader> -->
          </div>
          <div class="flex flex-between mb10">
            <div>
              添加商户：
              <el-button
                type="primary"
                plain
                size="small"
                :disabled="!applDepartNames"
                @click="merchantDialogVisible = true"
                >+ 添加商户
              </el-button>
            </div>
            <div>
              <el-button @click="output" type="primary" size="small"
                >导出模板
              </el-button>
              <el-button type="primary" size="small" class="open-file pointer"
                >导入表格
                <input
                  type="file"
                  class="pointer"
                  @change="importfs"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </el-button>
            </div>
          </div>
          <div class="table mb10">
            <el-table
              stripe
              ref="roleTable"
              :data="shopListNew"
              style="width: 100%"
              id="table"
              size="small"
              border
              max-height="400"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="商户名称"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="创建时间"
              ></el-table-column> -->
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip
                      class="item"
                      content="删除"
                      placement="top"
                      v-if="scope.row.delFlag !== '0'"
                    >
                      <div class="pointer mr10" @click="remove(scope.row)">
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
           <div
              class="hm-pagination shop-pagination"
            >
              <el-pagination
              background
              :total="selfCreatedShopListPageTotal"
              @current-change="createShopListPaginationPaging"
              @size-change="selfCreatedHandleSizeShopListChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="selfCreatedCurrentShopListPage"
                :page-size="selfCreatedPageShopListSize"
            ></el-pagination>
            </div>
        </el-form-item>

        <el-form-item label="添加商品:" prop="">
          <div class="flex flex-between item-center mb10">
            <div>
              <el-button type="primary" plain size="small" @click="editAddGoods"
                >+ 添加商品
              </el-button>
            </div>
            <div class="flex item-center">
              <el-button @click="outputExcel" type="primary" size="small"
                >导出模板
              </el-button>
              <el-button type="primary" size="small" class="open-file pointer"
                >导入表格
                <input
                  type="file"
                  class="pointer"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </el-button>
            </div>
          </div>
          <div class="table mb10">
            <el-table
              stripe
              ref="roleTable"
              :data="addGoodsListNew"
              style="width: 100%"
              id="table"
              size="small"
              border
              max-height="400"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="商品品牌"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsBarcode"
                label="商品条码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="rewardBaseMoney"
                label="单件奖励"
                v-if="
                  row.rewardMode === 'sub' || row.rewardMode === 'tiktokLikePas'
                "
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.delFlag == '0'">{{
                    scope.row.rewardBaseMoney
                  }}</span>
                  <el-input
                    type="text"
                    maxlength="8"
                    @input="
                      filterGt0OrGoodsListFixed2(
                        scope.$index,
                        'rewardBaseMoney'
                      )
                    "
                    @mousewheel.prevent.native
                    style="width: 100px"
                    v-model.trim="scope.row.rewardBaseMoney"
                    clearable
                    placeholder=""
                    size="small"
                    v-else
                  ></el-input>

                  元
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-tooltip
                      class="item"
                      content="删除"
                      placement="top"
                      v-if="scope.row.delFlag !== '0'"
                    >
                      <div class="pointer mr10" @click="removeGoods(scope.row)">
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
      </el-form>
      <!-- 编辑地方 -->
      <div
        class="hm-pagination"
      >
        <el-pagination
          background
          :total="selfCreatedPageTotal"
          @current-change="createYourOwnPaginationPaging"
          @size-change="selfCreatedHandleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="selfCreatedCurrentPage"
             :page-size="selfCreatedPageSize"
        >
        </el-pagination>
      </div>

      <span slot="footer" class="flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="submitEdit('ruleFormEdit')"
          >确 定</el-button
        >
        <el-button size="small" @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="1000px"
      :close-on-click-modal="false"
      :visible.sync="repeatGoodsDialogVisible"
    >
      <div slot="title">
        提示： <span class="primary"> 以下商品已参与同时段其他活动</span>
      </div>
      <div class="table">
        <el-table
          :data="repeatGoodsListNew"
          stripe
          border
          size="small"
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsName"
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="rewardName"
            label="已参加活动名称"
          >
            <template slot-scope="scope">
              <div>
                <el-button
                  v-for="(v, i) in scope.row.repeatRewardInfo"
                  :key="i"
                  type="text"
                  size="small"
                  class="blue"
                  @click="toDetails(v)"
                >
                  {{ v.rewardName }}
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <!-- <el-button
                  type="text"
                  size="small"
                  @click="toDetails(scope.row)"
                  >活动详情</el-button
                > -->
                <el-button
                  type="text"
                  size="small"
                  @click="importfGoods(scope.row, scope.$index)"
                  >导入
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="repeatGoodsTotal"
            @current-change="getRepeatGoodsCurrentPage"
            @size-change="getRepeatGoodsSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="repeatGoodsCurrentPage"
             :page-size="repeatGoodsPageSize"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="allImportfGoods"
          >全部继续添加
        </el-button>
        <el-button size="small" @click="delectImportfGoods"
          >全部不添加到活动
        </el-button>
        <el-button size="small" @click="repeatGoodsDialogVisible = false"
          >取 消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="报名表单"
      :visible.sync="formDialogVisible"
      width="1400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="common-dialog"
      append-to-body
    >
      <!-- <div class='remarks-info'>这里显示备注的信息，这里显示备注的信息</div> -->
      <!-- <el-form-item label="报名表单：" prop="formStatus">
        <el-radio-group v-model="ruleForm.formStatus">
          <el-radio label="open">开启</el-radio>
          <el-radio label="close">关闭</el-radio>
        </el-radio-group> -->
      <hm-form
        v-if="formDialogVisible"
        ref="hmform"
        :addGoodsList="addGoodsList"
        :initList="initList"
        :hmFormDisabled="hmFormDisabled"
      ></hm-form>
      <!-- </el-form-item> -->
      <template slot="footer">
        <el-button @click="formDialogConfirm" type="primary" size="small"
          >确定</el-button
        >
      </template>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods2" width="60%" title="导入失败提示">
      <div slot="title">
        <span style="lineheight: 24px; fontsize: 18px; color: #303133"
          >导入失败提示</span
        >
        <span class="danger"
          >品牌名有误或者商品名重复或者价格不正确会导致导入失败</span
        >
      </div>
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errInputResult2.length }}</span
            >条数据导入失败
          </div>
          <div>
            您有
            <span class="success"> {{ succInputResult2.length }}</span
            >条数据导入成功！
          </div>
        </div>

        <el-table :data="errInputResult2" border class="small-table">
          <el-table-column prop="brandName" label="商品品牌"></el-table-column>
          <el-table-column prop="goodsName" label="商品名称"></el-table-column>
          <el-table-column
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>

  <!-- 本地导入提示 -->
     <el-dialog :visible.sync="errValidStore3">
      <div slot="title">
        导入失败提示
        <span class="danger"
          >商品条码有误、商品条码重复或者商品条码不属于对应供应商会导致导入失败</span
        >
      </div>
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errStoreResult3.length }}</span
            >条数据导入失败
          </div>
          <!-- <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div> -->
        </div>
        <el-table
          :data="errStoreResult3"
          border
          class="small-table"
          max-height="500px"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsBarcode"
            label="商品条码"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-drawer
      title="导入商品"
      :visible.sync="drawerStep3Products"
      direction="rtl"
      size="700px"
    >
      <div class="p10">
        <!-- 导入excel -->
        <el-button type="success" size="small" class="open-file pointer"
          >本地导入
          <input
            type="file"
            class="pointer"
            @change="importfStep3Products"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </el-button>
        <div class="mt20" style="height: 700px">
          <el-scrollbar style="height: 100%" class="page-component__scroll">
            <el-table
              :data="step3ProductsRecords"
              style="width: 100%"
              id="table"
              size="small"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="fileName"
                label="文件名称"
              >
                <template slot-scope="scope">
                  <div class="flex flex-wrap item-center">
                    <el-tooltip
                      placement="top"
                      :content="
                        scope.row.fileName || scope.row.reportResultName
                      "
                      effect="dark"
                    >
                      <div
                        class="text-overflow"
                        style="width: 420px; color: #333"
                      >
                        {{ scope.row.fileName || scope.row.reportResultName }}
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="导入时间"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="cleanTime"
                label="过期时间"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createBy"
                label="导入人"
              >
              </el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="primary"
                    @click="introduceProducts(scope.row)"
                    >引入</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              :total="step3ProductsTotal"
              @current-change="step3ProductsCurrentChange"
              @size-change="step3ProductsSizeChange"
              layout="total,  prev, pager, next, jumper"
              :current-page="step3ProductsPage"
              :page-size="step3ProductsSize"
            >
            </el-pagination>
          </el-scrollbar>
        </div>
      </div>
    </el-drawer>
  </hm-content>
</template>

<script>
import moment from "moment";
import { Loading } from "element-ui";
import HmStep from "@/components/HmStep";
import HmForm from "@/components/HmForm3";
import HmDateSelect from "@/components/HmDateSelect";
import myUpload from "vue-image-crop-upload";
import _ from "lodash";
import { mapGetters } from "vuex";
import HmRichEditor from "@/components/HmRichEditor";
import HmBaseTransferNew from "@/components/HmBaseTransferNew";
import {
  arrayUnique2,
  isRepeat,
  compareDate,
  getSubtract,
  getRemove,
  setCookie,
  getCookie,
} from "@/utils/utils";
// import XLSX from "xlsx";
import * as XLSX from "xlsx/xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmStep,
    HmDateSelect,
    HmForm,
    myUpload,
    HmRichEditor,
    HmBaseTransferNew,
  },
  data() {
    const validatoRrewardNameFunc = (rule,val,callback) => {
      if(val) {
        let params = {
        supplierCode: this.$route.query.storeCode,
        rewardName: val
      };
       this.$store.dispatch(
        "verifyRewardRuleName",
        params
      ).then((res) => {
        console.log(res,9898)
        if(res.code !='0') {
          return callback(new Error("活动名称重复"));
        }else {
          callback();
        }
      }).catch(() => {
        return callback(new Error("活动名称重复"));
      })
      }else {
         return callback(new Error("请输入活动名称"));
      }
    }
    const autoOfflineDaysLimtFunc = (rule, val, callback) => {
      if (new Number(val) < new Number(this.numLimt)) {
        return callback(new Error("到期天数不能小于" + this.numLimt + "天"));
      }
      callback();
    };
    const validatorRewardFunc = (rule, val, callback) => {
      // if (
      //   this.ruleForm.rewardMode === "sub" ||
      //   this.ruleForm.rewardMode === "tiktokLikePas"
      // ) {
      //   if (val.length > 0) {
      //     let flag = false;
      //     val.forEach((v) => {
      //       if (v.rewardNumberLimit === "" || v.rewardValue === "") {
      //         flag = true;
      //       }
      //     });
      //     if (flag) {
      //       return callback(new Error("请填写完整规则！"));
      //     }
      //   }
      // } else {
        console.log(val,9999999)
       if (val.length === 0) {
        return callback(new Error("请添加活动规则"));
        } else {
          let flag = false;
          let previousRewardNumberLimit = null;

          val.forEach((v, index) => {
            if (v.rewardNumberLimit === "" || v.rewardValue === "") {
              flag = true;
            }

            if (index > 0 && previousRewardNumberLimit !== null) {
              if (parseFloat(v.rewardNumberLimit) <= parseFloat(previousRewardNumberLimit)) {
                flag = true;
                // this.$message.error(`第${index + 1}行的每组件数必须大于第${index}行的每组件数`);
              }
            }

            previousRewardNumberLimit = v.rewardNumberLimit;
          });

        if (flag) {
          return callback(new Error("请填写完整规则！"));
        }

        let ary = val.map((o) => o.rewardNumberLimit);
        if (isRepeat(ary)) {
          return callback(new Error("相同件数不允许重复！"));
        }
}
      // }

      callback();
    };
    const validatorFunc = (rule, val, callback) => {
      const {
        runningTimeType,
        ruleDateAndTime,
        ruleDate,
        dateType,
        dateValue,
        dateConfigRange,
        week,
        daysList,
      } = this.$refs.hmDateSelect;
      // 选择全时段
      if (runningTimeType === "all") {
        if ((ruleDateAndTime && !ruleDateAndTime[0]) || !ruleDateAndTime) {
          return callback(new Error("请选择日期"));
        }
        callback();
        // 选择特定时段
      } else if (runningTimeType === "special") {
        if (dateConfigRange && !dateConfigRange.length) {
          return callback(new Error("请选择促销时间"));
        } else if ((ruleDate && !ruleDate.length) || !ruleDate) {
          return callback(new Error("请选择促销日期"));
        }
        if (dateType === "day") {
          if (!dateValue) {
            return callback(new Error("请输入促销天数"));
          } else callback();
        } else if (dateType === "week") {
          if (week && !week.length) {
            return callback(new Error("请选择促销周"));
          }
          callback();
        } else if (dateType === "month") {
          if (daysList && !daysList.length) {
            return callback(new Error("请选择促销天"));
          }
          callback();
        }
      }
    };
    // const typeFunc = function(rule, val, callback) {
    //   if (val === "fixed") {
    //     if (this.ruleForm.rewardValue === "") {
    //       return callback(new Error("请输入缴费金额"));
    //     }
    //   } else if (val === "radio") {
    //     if (this.ruleForm.rewardValue === "") {
    //       return callback(new Error("请输入缴费比例"));
    //     } else {
    //       if (this.ruleForm.rewardValue > 100) {
    //         return callback(new Error("缴费比例不能超过100%"));
    //       }
    //     }
    //   }

    //   callback();
    // }.bind(this);
    return {
      selfCreatedCurrentPage: 1,
      selfCreatedPageSize: 10,
      selfCreatedPageTotal: 0,
      queryRewardGoodsEsPageListId: null,
      theTotalNumberOfUnits: 10,
      theTotalNumberOfUnits2: 10,
      addGoodsListNew: [],
      leftOption3: [],
      rightOption3: [],
      copyLeftOption3: [],
      repeatGoodsList: [], //真数据
      repeatGoodsCurrentPage: 1,
      repeatGoodsPageSize: 10,
      repeatGoodsTotal: 0,
      repeatGoodsListNew: [], //假数据
      goodsNumDetail: 0,
      repeatGoodsDialogVisible: false,
      errValidStore: false,
      errValidStoreDelete:false,
      successfulDeletion:0,
      errStoreResult: [],
      checkedRowList: [],
      checkedMerchantRow: [],
      numLimt: 0,
      ruleFormEdit: {
        autoOfflineDaysLimt: "",
        applDepartId: [],
      },
      rulesEdit: {
        autoOfflineDaysLimt: [
          {
            required: true,
            message: "请输入到期天数",
            trigger: "change",
          },
          {
            required: true,
            pattern: /^([1-9]\d*|[0]{1,1})$/,
            message: "请输入正整数",
            trigger: "change",
          },
          {
            required: true,
            validator: autoOfflineDaysLimtFunc,
            trigger: "blur",
          },
        ],
      },
      dialogVisibleEdit: false,
      ruleDate: [],
      showHeader: false,
      dialogVisibleTime: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < moment().subtract(1, "days");
        },
      },
      endTime: "",
      currentPageLog: 1,
      pageSizeLog: 10,
      totalLog: 0,
      dialogVisibleLog: false,
      ruleRelModelList: [],
      succInputResult: [],
      errInputResult: [],
      errValidGoods: false,
      dialogVisibleGood: false,
      ruleFormGood: {
        goodsName: "",
        goodsBarcode: "",
        hemiaoBrandId: "",
      },
      rulesGood: {
        goodsName: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
          {
            required: true,
            max: 30,
            message: "名称应大于30个字",
            trigger: "blur",
          },
        ],
        goodsBarcode: [
          {
            required: true,
            message: "请输入商品条码",
            trigger: "blur",
          },
        ],
        hemiaoBrandId: [
          {
            required: true,
            message: "请选择商品品牌",
            trigger: "blur",
          },
        ],
      },
      detailsDialogVisible: false,
      cascaderList: [],
      isShow: false,
      datePicker: true,
      props: {
        lazy: false,
        multiple: true,
        // checkStrictly: true,
        // lazyLoad: (node, resolve) => {
        //   const { level, data } = node;
        //   if (level === 0) {
        //     this.$store
        //       .dispatch("queryOrganizationList", {
        //         pageNo: 1,
        //         pageSize: 999,
        //         loginType: "supplier",
        //         storeCode: this.$route.query.storeCode,
        //       })
        //       .then((res) => {
        //         res.result.records.forEach((v) => {
        //           v.leaf = Boolean(!v.isParent);
        //           v.all = {
        //             label: v.departName,
        //             value: v.id || v.treeStruct,
        //           };
        //           v.value = v.all;
        //           v.label = v.departName;
        //         });
        //         resolve(res.result.records);
        //       });
        //   } else {
        //     this.$store
        //       .dispatch("queryListOrganizationListByParent", {
        //         parentId: data.treeStruct,
        //         loginType: "supplier",
        //         storeCode: this.$route.query.storeCode,
        //       })
        //       .then((res) => {
        //         if (res.code === "0" && res.result) {
        //           res.result.forEach((v) => {
        //             v.leaf = Boolean(!v.isParent);
        //             // v.value = v.id;
        //             // v.label = v.departName;
        //             v.all = {
        //               label: v.departName,
        //               value: v.id || v.treeStruct,
        //             };
        //             v.value = v.all;
        //             v.label = v.departName;
        //           });
        //           resolve(res.result);
        //         } else {
        //           resolve([]);
        //         }
        //       });
        //   }
        // },
      },
      propss: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationList", {
                pageNo: 1,
                pageSize: 999,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.id;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryListOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.id;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      searchCondition: {
        applyDepartIds: [],
        queryType: "goodsName",
      },
      currentPage: 1,
      pageSize: 10,
      storeNames: "",
      addGoodsList: [],
      holdeCheckedMerchantRow: [],
      currentMicroPage: 1,
      pageMicroSize: 10,
      checkedRow: [],
      checkedDelRow: [],
      dialogVisibleGoods: false,
      searchDialogCondition: {},
      addGood: {
        goodsName: "",
        goodsBarcode: "",
        hemiaoBrandId: "",
        storeCode: this.$route.query.storeCode,
      },
      shopList: [],
      shopListNew:[],
      selfCreatedShopListPageTotal: 0,
      selfCreatedCurrentShopListPage:1,
      selfCreatedPageShopListSize:10,
      options: [],
      value: "",
      list: [],
      loading: false,
      states: [],
      dialogVisible: false,
      merchantDialogVisible: false,
      shopDeletedDialogVisible: false,
      shopDeletedList:[],
      step: 1,
      merchantName: "",
      disabledFirst: false,
      ruleForm: {
        rewardName: "",
        rewardNumberLimit: "",
        rewardMode: "fixed", //普通活动 fixed   差异活动 sub  冲刺活动 radio  报名活动 tiktokLikePas
        // rewardMode: "tiktokLikePas",
        // rewardModeNew:'group', //奖励规则 
        distributionType:'group', //奖励活动类型 group-按组  item-按件
        maxDistributionAmount:'', //最大金额
        rewardValue: "",
        applDepartId: [],
        rewardRemark: "",
        autoOfflineDaysLimt: "",
        rewardStartDate: "",
        rewardEndDate: "",
        requiredGoodsMode: false,
        upperLimitSwitch: false,
        ruleRelModelList: [
          {
            rewardNumberLimit: "",
            rewardValue: "",
            index: 0,
          },
        ],
        adapterStoreType: "norm",
        actDesc: "",
      },
      rules: {
        validatorTime: {
          required: true,
          validator: validatorFunc,
          trigger: "blur",
        },
        rewardName: {
          required: true,
          // message: "请输入活动名称",
          validator: validatoRrewardNameFunc,
          trigger: "blur",
        },
        ruleRelModelList: [
          {
            required: true,
            validator: validatorRewardFunc,
            trigger: "blur",
          },
        ],
        rewardMode: [
          {
            required: true,
            message: "请选择活动方式",
            trigger: "blur",
          },
          // {
          //   required: true,
          //   validator: typeFunc,
          //   trigger: "blur"
          // }
        ],
         distributionType: [
          {
            required: true,
            message: "请选择奖励规则",
            trigger: "change",
          },
        ],
        applDepartId: [
          {
            required: true,
            message: "请选择匹配组织架构",
            trigger: "blur",
          },
        ],
        autoOfflineDaysLimt: {
          required: true,
          message: "请输入活动下线时间",
          trigger: "change",
        },
        adapterStoreType: {
          required: true,
          message: "请选择适配商户类型",
          trigger: "change",
        },
      },
      type: "",
      flag: false,
      row: {},
      logList: [],
      editTimeShow: false,
      autoOfflineDaysLimt: "",
      applDepartNames: "",
      checkedShopRowList: [],
      shopSearchVal: "",
      goodSearchVal: "",
      edit_enddate: true,
      editwxName: "",
      selectActivityIndex: null,
      storeBasicInfoListBoxList: [],
      batchCondition: {
        ruleDate: "",
        endTime: "",
      },
      dialogVisibleTimeBatch: false,
      edit_rewardName: true,
      editrewardName: "",
      formDialogVisible: false,
      errValidGoods2: false,
      columnsInfoModels: [],
      initList: [],
      hmFormDisabled: false,
      showDetail: false,
      show: false,
      listHeaderImgUrl: "",
      uploadedDetailList: [],
      errInputResult2: [],
      succInputResult2: [],
      tableData: [{}],
      // 步骤三的 导入商品的数据
      drawerStep3Products: false,
      step3ProductsFileName: null,
      step3ProductsRecords: [],
      step3ProductsPage: 1,
      step3ProductsSize: 10,
      step3ProductsTotal: 0,
      errValidStore3 : false,
      errStoreResult3 : [],
      isShowRewards : 'fiexd',
      // 第一步 普通活动 -奖励规则
     
    };
    
  },
  computed: {
    // vuex的
    ...mapGetters([
      "supplierRewardRuleInfoList",
      "storeBasicInfoListBox",
      "departBindingStoreBox",
      "supplierGoodsInfoList",
      "hemiaoBrandBoxList",
      "detailsSupplierBasicInfo",
    ]),
    // 页面自带的
    stepsComputed: function() {
      if (this.ruleForm.requiredGoodsMode) {
        return [
          {
            name: "活动规则",
          },
          {
            name: "适用商户",
          },
          {
            name: "适用商品",
          },
          {
            name: "设置必有商品",
          },
          {
            name: "创建活动",
          },
        ];
      } else {
        return [
          {
            name: "活动规则",
          },
          {
            name: "适用商户",
          },
          {
            name: "适用商品",
          },
          {
            name: "创建活动",
          },
        ];
      }
    },
  },
  watch: {},
  created() {
    this.debouncedFilterGt0OrListFixed0 = _.debounce(
      this.filterGt0OrListFixed0,
      300
    );
  },
  mounted() {
    this.storeNames = localStorage.getItem("storeName");
    this.getParamsCookie();
    this.queryList();
    this.initCategory();
    this.$store.dispatch("queryStoreBasicInfoListBox", {
      supplierCode: this.$route.query.storeCode,
    });
  },
  methods: {
    createYourOwnPaginationPaging(val) {
      this.selfCreatedCurrentPage = val;
      this.getAddGoodsList();
    },
     createShopListPaginationPaging(val) {
      this.selfCreatedCurrentShopListPage = val;
      this.getAddShopList();
    },
    selfCreatedHandleSizeChange(val) {
      this.selfCreatedCurrentPage = 1;
      this.selfCreatedPageSize = val;
      this.getAddGoodsList();
    },
    selfCreatedHandleSizeShopListChange(val) {
      this.selfCreatedCurrentShopListPage = 1;
      this.selfCreatedPageShopListSize = val;
      this.getAddShopList();
    },
    limitInput(val, limitVal, index) {
      if (val > limitVal) {
        this.ruleForm.ruleRelModelList[
          index
        ].rewardRequiredNum = this.ruleForm.ruleRelModelList[
          index
        ].rewardNumberLimit;
      }
      if (val < 0) {
        this.ruleForm.ruleRelModelList[index].rewardRequiredNum = 0;
      }
    },
    getTransferResult3(list) {
      console.log("list2::", list);
      this.rightOption3 = list;
    },
    initCategory() {
      this.$store
        .dispatch("queryPageDepartInfoList", {
          pageNo: 1,
          pageSize: 999,
          loginType: "supplier",
          storeCode: this.$route.query.storeCode,
        })
        .then((res) => {
          console.log("---initCategory---", res);
          const list = res.result.records.map((v) => {
            v.all = {
              label: v.departName,
              value: v.id || v.treeStruct,
            };
            v.value = v.all;
            v.label = v.departName;
            this.deepDeal(v);
            return v;
          });
          console.log("---list---", list);
          this.cascaderList = list;
        });
    },
    deepDeal(v) {
      if (v.children && v.children.length) {
        v.children.map((item) => {
          item.all = {
            label: item.departName,
            value: item.id || item.treeStruct,
          };
          item.value = item.all;
          item.label = item.departName;
          this.deepDeal(item);
          return item;
        });
      } else {
        v.children = null;
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.storeBasicInfoListBoxList = this.storeBasicInfoListBox.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicInfoListBoxList = [];
      }
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log("rowIndex", rowIndex);
      // console.log("selectActivityIndex", this.selectActivityIndex);
      if (rowIndex == this.selectActivityIndex) {
        return "activity-style";
      } else {
        return "";
      }
    },
    changeEnddate() {
      this.editwxName = this.row.rewardName;
      this.edit_enddate = !this.edit_enddate; //直接加key
      // this.list = [...this.list];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs.enddateinput.focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    enddateblur() {
      if (
        this.row.rewardName === "" ||
        this.row.rewardName === this.editwxName
      ) {
        this.row.rewardName = this.editwxName;
      }
      this.edit_enddate = !this.edit_enddate;
    },
    changeRewardName() {
      this.editrewardName = this.ruleForm.rewardName;
      this.edit_rewardName = !this.edit_rewardName; //直接加key
      // this.list = [...this.list];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs.rewardNameinput.focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    rewardNameblur() {
      if (
        this.ruleForm.rewardName === "" ||
        this.ruleForm.rewardName === this.editrewardName
      ) {
        this.ruleForm.rewardName = this.editrewardName;
      }
      this.edit_rewardName = !this.edit_rewardName;
    },
    tableSelect(row, column, event, tableName) {
      console.log("tableSelect", row, column, event, tableName);
      if (column.label != "操作" && column.label != "单件奖励") {
        this.$refs[tableName].toggleRowSelection(row);
      }
    },
    getShopBatchChecked(selection) {
      this.checkedShopRowList = selection;
    },
    batchRemoveShops() {
      if (this.checkedShopRowList.length) {
        this.shopList = getSubtract(
          this.shopList,
          this.checkedShopRowList,
          "storeCode"
        );
         this.shopListNew = getSubtract(
          this.shopListNew,
          this.checkedShopRowList,
          "storeCode"
        );
         this.getAddShopList();
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    allBatchRemoveShops() {
      this.shopList = [];
      this.shopListNew = [];
      this.getAddShopList();
    },
    batchRemove() {
      if (this.checkedRowList.length) {
        console.log("this.checkedRowList", this.checkedRowList);

        this.addGoodsList = getSubtract(
          this.addGoodsList,
          this.checkedRowList,
          "supplierGoodsId"
        );
        this.addGoodsListNew = getSubtract(
          this.addGoodsListNew,
          this.checkedRowList,
          "supplierGoodsId"
        );
        this.getAddGoodsList();
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },

    allRemove() {
      this.addGoodsList = [];
      this.addGoodsListNew = [];
      this.getAddGoodsList();
    },
    getBatchChecked(selection) {
      console.log("getBatchChecked", selection);
      this.checkedRowList = selection;
    },
    addChildSub() {
      this.ruleForm.ruleRelModelList.push({
        rewardNumberLimit: "",
        rewardValue: "",
        rewardSubNum: "",
      });
    },
    rewardModeChange(val) {
      this.isShowRewards = val
      this.ruleForm.requiredGoodsMode = false;
      this.ruleForm.upperLimitSwitch = false;
      if (val === "sub" || val === "tiktokLikePas") {
        this.ruleForm.ruleRelModelList = [];
      } else {
        this.ruleForm.ruleRelModelList = [
          {
            rewardNumberLimit: "",
            rewardValue: "",
          },
        ];
      }
    },
     rewardModeNewChange(val) { //奖励规则 切换
      console.log("rewardModeNewChange", val);
      this.ruleForm.distributionType = val
     
      this.ruleForm.maxDistributionAmount = ''
      this.ruleForm.requiredGoodsMode = false;
      this.ruleForm.upperLimitSwitch = false;
      if (val === "sub" || val === "tiktokLikePas") {
        this.ruleForm.ruleRelModelList = [];
      } else {
        this.ruleForm.ruleRelModelList = [
          {
            rewardNumberLimit: "",
            rewardValue: "",
          },
        ];
      }
    },
    async submit() {
      if (this.editTimeShow) {
        if (this.ruleDate.length) {
          let params = {
            rewardRuleId: this.row.rewardRuleId,
            rewardStartDate: this.ruleDate[0],
            rewardEndDate: this.ruleDate[1],
          };
          const { code } = await this.$store.dispatch(
            "editRewardRuleEndDate",
            params
          );
          if (code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.dialogVisibleTime = false;
            this.queryList();
          }
        } else {
          this.$message({
            message: "请选择时段！",
            type: "warning",
          });
        }
      } else {
        if (this.endTime !== "") {
          let params = {
            rewardRuleId: this.row.rewardRuleId,
            rewardEndDate: this.endTime,
          };
          const { code } = await this.$store.dispatch(
            "editRewardRuleEndDate",
            params
          );
          if (code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.dialogVisibleTime = false;
            this.queryList();
          }
        } else {
          this.$message({
            message: "请选择结束时间！",
            type: "warning",
          });
        }
      }
    },
    editTime(row) {
      this.row = row;
      let mydate = moment().format("YYYY/MM/DD");
      this.editTimeShow = compareDate(
        row.timeFormatValue.split("至")[0],
        mydate.replace(/\//g, "-")
      );
      // if (this.editTimeShow) {
      //   this.ruleDate = [
      //     row.timeFormatValue.split("至")[0],
      //     row.timeFormatValue.split("至")[1]
      //   ];
      // } else {
      //   this.endTime = row.timeFormatValue.split("至")[1];
      // }
      this.dialogVisibleTime = true;
    },
    addChild() {
      this.ruleForm.ruleRelModelList.push({
        rewardNumberLimit: "",
        rewardValue: "",
        index:
          this.ruleForm.ruleRelModelList[
            this.ruleForm.ruleRelModelList.length - 1
          ].index + 1,
      });
      console.log(this.ruleForm.ruleRelModelList);
      // this.flag = false;
      // this.ruleForm.ruleRelModelList.forEach(v => {
      //   if (v.rewardNumberLimit === this.ruleForm.rewardNumberLimit) {
      //     this.flag = true;
      //   }
      // });
      // if (!this.flag) {
      //   this.ruleForm.ruleRelModelList.push({
      //     rewardNumberLimit: this.ruleForm.rewardNumberLimit,
      //     rewardValue: this.ruleForm.rewardValue
      //   });
      // }
    },
    delRule(index) {
      this.ruleForm.ruleRelModelList.splice(index, 1);
    },
    importfs(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        // let importfList = [];
        that.errStoreResult = [];
        result.forEach((v) => {
          if (v[0]) {
            formatResult.push({
              storeName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
            });
          }
        });

        formatResult.forEach((v) => {
          let i = that.departBindingStoreBox.findIndex(
            (o) => o.storeName === v.storeName
          );

          if (i > -1) {
            that.shopList.push(that.departBindingStoreBox[i]);
          } else {
            that.errStoreResult.push(v);
          }
        });
        if (that.errStoreResult.length) {
          that.errValidStore = true;
        }
        that.shopList = arrayUnique2(that.shopList, "storeName");
        if (that.shopList.length) {
           that.getAddShopList();
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    importfDelete(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        // let importfList = [];
        that.errStoreResult = [];
        result.forEach((v) => {
          if (v[0]) {
            formatResult.push({
              storeName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
            });
          }
        });

       // 创建一个对象映射，存储 storeName 和其在 shopList 中的索引
          let shopListMap = {};
          that.shopList.forEach((shop, index) => {
            shopListMap[shop.storeName] = index;
          });

          formatResult.forEach((v) => {
            if (shopListMap[v.storeName] !== undefined) {
              // 找到相同的 storeName，删除 that.shopList 中对应的项
              that.shopList.splice(shopListMap[v.storeName], 1);
              // 更新 shopListMap 以保持一致性
              delete shopListMap[v.storeName];
              // 重新构建 shopListMap 以确保索引正确
              shopListMap = {};
              that.shopList.forEach((shop, index) => {
                shopListMap[shop.storeName] = index;
              });
            } else {
              // 不存在，添加到 that.errStoreResult 中
              that.errStoreResult.push(v);
            }
          });
        if (!Array.isArray(formatResult) || !Array.isArray(that.errStoreResult)) {
          that.successfulDeletion = 0; // 设置默认值为 0
        } else {
          // 计算 successfulDeletion，确保结果非负
          const successfulCount = formatResult.length - that.errStoreResult.length;
          that.successfulDeletion = Math.max(0, successfulCount); // 防止负值
        }
        if (that.errStoreResult.length) {
          that.errValidStoreDelete = true;
        }else {
           that.$message({
                message: `成功删除${formatResult.length}条数据`,
                type: "success",
              });
        }
        that.shopList = arrayUnique2(that.shopList, "storeName");
         that.getAddShopList();
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 新增活动---步骤三（使用商品）添加商品后的调用
    async supplierGoodsInfoCheckGoods(checkGoodsList) {
      let params = {
        supplierGoodsIdList: checkGoodsList.map((v) => v.supplierGoodsId),
        applyStoreCodes: this.shopList.map((v) => v.storeCode),
        rewardStartDate: this.ruleForm.rewardStartDate,
        rewardEndDate: this.ruleForm.rewardEndDate,
      };
      const { result } = await this.$store.dispatch(
        "supplierGoodsInfoCheckGoodsNew",
        params
      );
      console.log("新增活动---步骤三（使用商品）添加商品后的调用", result);

      if (result.length) {
        let goodsList = [];
        this.repeatGoodsDialogVisible = true;
        checkGoodsList.forEach((v) => {
          result.forEach((o) => {
            if (o.goodsBarcode === v.goodsBarcode) {
              goodsList.push(Object.assign({}, o, v));
            }
          });
        });
        console.log("result2", goodsList);
        this.repeatGoodsList = goodsList;
        this.getRepeatGoodsList();
      }else {
        console.log(checkGoodsList,1213)
        this.addGoodsList.unshift(...checkGoodsList);
        this.addGoodsListNew.unshift(...checkGoodsList);
      }
      // arrayUnique2 去重   getSubtract 求差集
     
      let acnm = arrayUnique2(result, "supplierGoodsId");
      let subList = getSubtract(checkGoodsList, acnm, "supplierGoodsId");
      this.addGoodsList.push(...subList);
      this.addGoodsListNew.push(...subList);
      this.addGoodsList = arrayUnique2(this.addGoodsList, "supplierGoodsId");
      this.addGoodsListNew = arrayUnique2(
        this.addGoodsListNew,
        "supplierGoodsId"
      );

      // console.log('这里');
      // console.log(this.addGoodsList);
      console.log("result3", this.addGoodsList);
      console.log("result4", this.addGoodsListNew);
      // 对所有的数据操作在这处理
      await this.getAddGoodsList();
      // if (this.addGoodsList && this.addGoodsList.length > 10) {
      //   this.addGoodsListNew = this.addGoodsList.slice(
      //     this.selfCreatedCurrentPage - 1,
      //     this.theTotalNumberOfUnits
      //   );
      // } else {
      //   this.addGoodsListNew.push(this.addGoodsList);
      // }
      console.log("错误的地方", this.addGoodsListNew);
    },

    getGoodSearchVal(e) { // 第三步本地搜索所有商品
      if(e +'') {
         this.addGoodsListNew = this.addGoodsList
      }else {
         this.getAddGoodsList()
      }
    },

    clearGoodSearchVal() {
      this.goodsSearchVal = "";
      this.getAddGoodsList()
    },

    getShopSearchVal(e) { // 第二步地搜索所有商品
      if(e +'') {
         this.shopListNew = this.shopList
      }else {
         this.getAddShopList()
      }
    },

    clearShopSearchVal() {
      this.shopSearchVal = "";
      this.getAddShopList()
    },

  async getAddShopList() {
      // shopList 存所有数据     shopListNew 当前分页的数据
      const totalPages = Math.ceil(this.shopList.length / this.selfCreatedPageShopListSize);
      if (this.selfCreatedCurrentShopListPage > totalPages) {
            this.selfCreatedCurrentShopListPage = totalPages || 1; // 确保至少为第一页
          }
      this.selfCreatedShopListPageTotal = this.shopList.length;
      console.log("getAddShopList", this.shopList.length,this.selfCreatedShopListPageTotal);
      // 获取当前页的第一项
      const startIndex =
        (this.selfCreatedCurrentShopListPage - 1) * this.selfCreatedPageShopListSize;
      const endIndex = this.selfCreatedCurrentShopListPage * this.selfCreatedPageShopListSize;
      this.shopListNew = this.shopList.slice(startIndex, endIndex);
      console.log("startIndex", startIndex);
      console.log("endIndex", endIndex);
      console.log("根据假分页处理的数据", this.shopListNew);
      this.$nextTick(() => {
         this.shopListNew = this.shopList.slice(startIndex, endIndex);
	    });
      this.$forceUpdate()
    },
  

    async getAddGoodsList() {
      // addGoodsList 存所有数据     addGoodsListNew 当前分页的数据
       const totalPages = Math.ceil(this.addGoodsList.length / this.selfCreatedPageSize);
      if (this.selfCreatedCurrentPage > totalPages) {
            this.selfCreatedCurrentPage = totalPages || 1; // 确保至少为第一页
          }
      this.selfCreatedPageTotal = this.addGoodsList.length;
      console.log("getAddGoodsList", this.selfCreatedPageTotal);
      // 获取当前页的第一项
      const startIndex =
        (this.selfCreatedCurrentPage - 1) * this.selfCreatedPageSize;
      const endIndex = this.selfCreatedCurrentPage * this.selfCreatedPageSize;
      this.addGoodsListNew = this.addGoodsList.slice(startIndex, endIndex);
      console.log("startIndex", startIndex);
      console.log("endIndex", endIndex);
      console.log("根据假分页处理的数据", this.addGoodsListNew);
      this.$nextTick(() => {
         this.addGoodsListNew = this.addGoodsList.slice(startIndex, endIndex);
	    });
      this.$forceUpdate()
    },
    getRepeatGoodsList() {
      // addGoodsList 存所有数据     addGoodsListNew 当前分页的数据
      this.repeatGoodsTotal = this.repeatGoodsList.length;
      console.log("getRepeatGoodsList", this.repeatGoodsTotal);
      // 获取当前页的第一项
      const startIndex =
        (this.repeatGoodsCurrentPage - 1) * this.repeatGoodsPageSize;
      const endIndex = this.repeatGoodsCurrentPage * this.repeatGoodsPageSize;
      this.repeatGoodsListNew = this.repeatGoodsList.slice(
        startIndex,
        endIndex
      );
      console.log("startIndex", startIndex);
      console.log("endIndex", endIndex);
      console.log(
        " 以下商品已参与同时段其他活动的数据",
        this.repeatGoodsListNew
      );
    },

    getRepeatGoodsCurrentPage(val) {
      this.repeatGoodsCurrentPage = val;
      this.getRepeatGoodsList();
    },
    getRepeatGoodsSizeChange(val) {
      this.repeatGoodsCurrentPage = 1;
      this.repeatGoodsPageSize = val;
      this.getRepeatGoodsList();
    },

    // 导入
    importfGoods(row, i) {
      this.addGoodsList.unshift(row);
      this.addGoodsList = arrayUnique2(this.addGoodsList, "supplierGoodsId");
      this.addGoodsListNew.unshift(row);
      this.addGoodsListNew = arrayUnique2(
        this.addGoodsListNew,
        "supplierGoodsId"
      );
      this.repeatGoodsList.splice(i, 1);
    },
    // 全部继续添加
    allImportfGoods() {
      this.addGoodsList.unshift(...this.repeatGoodsList);
      this.addGoodsList = arrayUnique2(this.addGoodsList, "supplierGoodsId");
      this.addGoodsListNew.unshift(...this.repeatGoodsList);
      this.addGoodsListNew = arrayUnique2(this.addGoodsList, "supplierGoodsId");
      this.repeatGoodsList = [];
      this.getAddGoodsList();
      this.repeatGoodsDialogVisible = false;
    },
    delectImportfGoods() {
      this.addGoodsList.forEach((v) => {
        this.repeatGoodsList.forEach((o) => {
          if (v.supplierGoodsId === o.supplierGoodsId) {
            v.repeat = true;
          }
        });
      });
      this.addGoodsList = this.addGoodsList.filter((item) => !item.repeat);
      this.addGoodsListNew.forEach((v) => {
        this.repeatGoodsList.forEach((o) => {
          if (v.supplierGoodsId === o.supplierGoodsId) {
            v.repeat = true;
          }
        });
      });
      this.addGoodsListNew = this.addGoodsListNew.filter(
        (item) => !item.repeat
      );

      this.repeatGoodsList = [];
      this.repeatGoodsDialogVisible = false;
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let fileName = f.name;
      console.log("文件名: ", fileName);
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        console.log("导入excel::", wb);

        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        let importfList = [];

        result.forEach((v) => {
          if (v[0]) {
            formatResult.push({
              goodsBarcode: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              storeCode: that.$route.query.storeCode,
            });
            if (
              that.ruleForm.rewardMode === "sub" ||
              that.ruleForm.rewardMode === "tiktokLikePas"
            ) {
              importfList.push({
                goodsBarcode: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
                rewardBaseMoney: v[1] ? +v[1] : "",
              });
            }
          }
        });

        console.log("导入excel-result::", result);

        that.$store
          .dispatch("exportRewardGoodsSupplier", formatResult)
          .then((res) => {
            const { code, result } = res;
            console.log("调接口");

            if (code === "0") {
              const { failList, successList } = result;

              if (failList.length) {
                setTimeout(() => {
                  that.errValidGoods = true;
                }, 100);
                that.errInputResult = failList;
                that.$message({
                  message: "部分条码导入失败！",
                  type: "warning",
                });
              }
              that.succInputResult = successList;

              let goodsList = [];
              console.log(
                "that.ruleForm.rewardMode: ",
                that.ruleForm.rewardMode
              );
              if (
                that.ruleForm.rewardMode === "sub" ||
                that.ruleForm.rewardMode === "tiktokLikePas"
              ) {
                importfList.forEach((v) => {
                  v.rewardBaseMoney = v.rewardBaseMoney
                    ? v.rewardBaseMoney.toFixed(2)
                    : "";
                });
                successList.forEach((v) => {
                  importfList.forEach((o) => {
                    if (o.goodsBarcode === v.goodsBarcode) {
                      goodsList.push(Object.assign({}, o, v));
                    }
                  });
                });
              } else {
                goodsList = successList;
              }
              that.supplierGoodsInfoCheckGoods(goodsList);
              that.$forceUpdate();
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },

    // 本地导入
    importfStep3Products(e) {
      console.log("步骤三的本地导入");
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let fileName = f.name;
      console.log("文件名: ", fileName);
      this.step3ProductsFileName = fileName;
      let reader = new FileReader();
      reader.onload = async function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        let importfList = [];
        result.forEach((v) => {
          if (v[0]) {
            const item = {
              goodsBarcode: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              storeCode: that.$route.query.storeCode,
            };
            if (
              that.ruleForm.rewardMode === "sub" ||
              that.ruleForm.rewardMode === "tiktokLikePas"
            ) {
              item.rewardBaseMoney = v[1] ? +v[1] : "";
            }
            formatResult.push(item);
            if (
              that.ruleForm.rewardMode === "sub" ||
              that.ruleForm.rewardMode === "tiktokLikePas"
            ) {
              importfList.push({
                goodsBarcode: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
                rewardBaseMoney: v[1] ? +v[1] : "",
              });
            }
          }
        });
        const { code,result: errorResult } = await that.$store.dispatch("rewardGoodsImportEs", {
          modelList: formatResult,
          importFileName: fileName,
        });
        if (code === "0") {
          await that.step3Products();
          console.log("step3ProductsFileName:", that.step3ProductsFileName);
          // console.log(
          //   "step3ProductsRecords[0].fileName:",
          //   that.step3ProductsRecords[0].fileName
          // );

          // if (
          //   that.step3ProductsFileName === that.step3ProductsRecords[0].fileName
          // ) {
          //   console.log("这代表这是最新的文件并且是我自己上传的文件");
          //   setTimeout(() => {
          //     that.introduceProducts(that.step3ProductsRecords[0]);
          //   }, 10);
          // }
          // that.drawerStep3Products = false;
          // that.supplierGoodsInfoCheckGoods(goodsList);
          // that.$forceUpdate();
          if(errorResult.failList && errorResult.failList.length) {
            that.errStoreResult3 = errorResult.failList;
            that.errValidStore3 = true;
          }
           if(errorResult.successList && errorResult.successList.length) {
             that.drawerStep3Products = false;
             that.supplierGoodsInfoCheckGoods(errorResult.successList);
          }
          // that.addGoodsListNew = errorResult.successList
         
          console.log("引入-result:", errorResult);
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },

    // 引入
    async introduceProducts(scope) {
      // 获取引入的数据
      try {
        const res = await this.$store.dispatch("queryRewardGoodsEsPageList", {
          id: scope.id,
          pageNo: 1,
          pageSize: 99999,
          // pageNo: this.selfCreatedCurrentPage,
          // pageSize: this.selfCreatedPageSize,
        });
        // supplierGoodsInfoCheckGoods;
        console.log("引入-introduceProducts", res);
        // this.importGoodsEsRecordId = scope.id;
        this.drawerStep3Products = false;
        this.supplierGoodsInfoCheckGoods(res.result.records);
        this.$forceUpdate();
      } catch (error) {}
    },

    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商户名称"];
        const data = [];
        exportJsonToExcel(tHeader, data, "导入商户模板");
      });
    },
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");

        const tHeader =
          this.ruleForm.rewardMode === "sub" ||
          this.ruleForm.rewardMode === "tiktokLikePas"
            ? ["商品条码(单次最多导入200条)", "单件奖励"]
            : ["商品条码(单次最多导入200条)"];
        const data = [];
        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    // 导出奖励金额模板
     outputExcelRewards() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
         const tHeader = ["组件数（必填）","组奖励金额（元）"];
        // const tHeader =
        //   this.ruleForm.rewardMode === "sub" ||
        //   this.ruleForm.rewardMode === "tiktokLikePas"
        //     ? ["商品条码(单次最多导入200条)", "单件奖励"]
        //     : ["商品条码(单次最多导入200条)"];
        const data = [];
        exportJsonToExcel(tHeader, data, "奖励规则导入模板");
      });
    },
    // 导入奖励金额数据
    importfsRewards(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      let loading;
     reader.onload = function(e) {
       loading = Loading.service({
        lock: true,
        text: "卖力加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0)"
      });
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
       if(result && result.length == 0) {
         loading.close();
         that.$message.error(`请导入正确的模板`);
         return
       }
        for (let i = 0; i < result.length; i++) {
         const v = result[i];
        if (v[0] && v[1]) {
        formatResult.push({
          index: i,
          rewardNumberLimit: v[0] ? (v[0] + "").replace(/[^\d]+/g, "") : "",
          rewardValue: v[1] ? (v[1] + "").replace(/^(0+)/, "") : "",
        });
        } else {
          if(v[0] || v[1]) {
             loading.close();
            formatResult = []
            that.$message.error(`导入的第${i + 1}行数据不完整，请修正后导入`);
            return; // 打断循环
          }
        
        }
      }
        // formatResult.forEach((v) => {
          // let i = that.departBindingStoreBox.findIndex(
          //   (o) => o.storeName === v.storeName
          // );

          // if (i > -1) {
          //   that.shopList.push(that.departBindingStoreBox[i]);
          // } else {
          //   that.errStoreResult.push(v);
          // }
        // });
      if(formatResult.length) {
        let previousValue = 0;
        for (let i = 0; i < formatResult.length; i++) {
             const item = formatResult[i];
             const currentRewardNumberLimit = Number(item.rewardNumberLimit);
        if (isNaN(currentRewardNumberLimit)) {
             loading.close();
             that.$message.error(`第 ${i + 1} 项的商品件数无效，请检查数据`);
          return; // 中断循环
        }
        if (currentRewardNumberLimit <= previousValue) {
          loading.close();
          that.$message.error(`第 ${i + 1} 项的商品件数必须大于第 ${i} 项的商品件数，请修正后重新上传`);
          return; // 中断循环
        }
          previousValue = currentRewardNumberLimit;
       }
        that.ruleForm.ruleRelModelList = formatResult;
        loading.close();
        that.$message.success('导入成功')
      }else {
         loading.close();
      }
        console.log("引入-result:9999999", formatResult,that.ruleForm.ruleRelModelList);
        // if (that.errStoreResult.length) {
        //   that.errValidStore = true;
        // }
        // that.shopList = arrayUnique2(that.shopList, "storeName");
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    changgeaa() {
      this.type = "add";
      if (this.type === "add") {
        this.value = [];
        this.shopList = [];
        this.shopListNew = []
        this.ruleForm.applyDepartNames = [];
        this.ruleForm.applyDepartIds = [];
        this.ruleForm.applDepartId.forEach((v) => {
          this.ruleForm.applyDepartIds.push(v[v.length - 1].value);
          this.ruleForm.applyDepartNames.push(v[v.length - 1].label);
        });
      }
      if (this.ruleForm.applyDepartIds.length) {
        this.queryStoreBoxList();
      }
    },
    filterGt0OrFixed0(prop) {
      if (prop !== "autoOfflineDaysLimt") {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      }

      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    filterGt0OrFixed00(prop) {
      if (prop === "addDays") {
        this.batchCondition[prop] = this.batchCondition[prop].replace(
          /^(0+)/,
          ""
        ); //过滤0开头
      }

      this.batchCondition[prop] = this.batchCondition[prop].replace(
        /[^\d]/g,
        ""
      );
      this.batchCondition[prop] = this.batchCondition[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    selectAll() {
      if (this.value.length < this.departBindingStoreBox.length) {
        this.value = [];
        this.departBindingStoreBox.map((item) => {
          this.value.push(`${item.storeName},${item.storeCode}`);
        });
        this.value.unshift("all");
      } else {
        this.value = [];
      }
    },
    changeSelect(val) {
      if (
        !val.includes("all") &&
        val.length === this.departBindingStoreBox.length
      ) {
        this.value.unshift("all");
      } else if (
        val.includes("all") &&
        val.length - 1 < this.departBindingStoreBox.length
      ) {
        this.value = this.value.filter((item) => {
          return item !== "all";
        });
      }
    },
    removeTag(val) {
      if (val === "all") {
        this.value = [];
      }
    },
    del(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        let params = {
          rewardRuleIds: [row.rewardRuleId],
          supplierCode: this.$route.query.storeCode,
        };
        this.$store
          .dispatch("delSupplierRewardRuleInfoList", params)
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success",
              });
              this.queryList();
            }
          });
      });
    },
    async operationLog(row, index) {
      this.selectActivityIndex = index;
      this.dialogVisibleLog = true;
      this.row = row;
      this.pageSizeLog = 10;
      this.currentPageLog = 1;
      this.queryLogList();
    },

    // 超出上限设置的弹窗提示
    upperLimitSwitchChange(val) {
      console.log("upperLimitSwitchChange", val);

      if (val == false) return (this.ruleForm.upperLimitSwitch = false);
      // 创建 this.$createElement 别名
      const h = this.$createElement;
      const maxMoney = parseFloat(
        this.ruleForm.ruleRelModelList[
          this.ruleForm.ruleRelModelList.length - 1
        ]["rewardValue"]
      );
      console.log("maxMoney", maxMoney);

      if (maxMoney > 0) {
        const maxRewardAmount = maxMoney + "元";
        const messageElement = h("p", null, [
          h("i", {
            class: "el-icon-warning",
            style: { color: "#F56C6C", fontSize: "16px" },
          }),
          h(
            "span",
            null,
            "请您确认开启该规则设置，开启后将以您设定的最高奖励金额 ("
          ),
          h("span", { style: { color: "#F56C6C" } }, maxRewardAmount),
          h("span", null, ") 为上限"),
        ]);
        // 显示消息框
        this.$msgbox({
          title: "重要提示",
          message: messageElement,
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            // 确认操作成功提示
            return (this.ruleForm.upperLimitSwitch = true);
          })
          .catch(() => {
            // 取消操作提示
            return (this.ruleForm.upperLimitSwitch = false);
          });
      } else {
        this.ruleForm.upperLimitSwitch = false;
        this.$message.error("请输入规则奖励金额");
      }
    },

    async queryLogList() {
      let params = {
        pageSize: this.pageSizeLog,
        pageNo: this.currentPageLog,
        bizDataPk: this.row.rewardRuleId,
        bizType: "redMoneyReward",
      };
      const { result } = await this.$store.dispatch(
        "storeOperationLogList",
        params
      );
      this.logList = result.records;
      this.totalLog = result.total;
    },
    toDetails(row, index) {
      console.log("--row.rewardMode--", row.rewardMode);
      // 搭配活动
      if (row.rewardMode === "collocation") {
        this.$router.push({
          path: "/guiderCommission/addMatchActivityManagement",
          type: "add",
          query: {
            storeCode: this.$route.query.storeCode,
            row: JSON.stringify({
              rewardRuleId: row.rewardRuleId,
              rewardName: row.rewardName,
            }),
            type: "detail",
          },
        });
        return;
      }
      // 原有逻辑
      this.selectActivityIndex = index;
      this.$store
        .dispatch("detailsSupplierRewardRuleInfoList", {
          rewardRuleId: row.rewardRuleId,
        })
        .then((res) => {
          this.addGoodsList = res.result.goodsList;
          this.getAddGoodsList();
          this.getAddShopList();
          if (
            res.result.requiredGoodsLimitInfo &&
            res.result.requiredGoodsLimitInfo.goodsNum
          ) {
            this.goodsNumDetail = res.result.requiredGoodsLimitInfo.goodsNum;
          } else {
            this.goodsNumDetail = 0;
          }

          // this.ruleForm.requiredGoodsMode = res.result.requiredGoodsMode == 'yes' ? true : false;

          if (row.rewardMode === "tiktokLikePas") {
            this.$store
              .dispatch("subActivityDetails", {
                id: res.result.ruleInfo.relPasId,
              })
              .then((res2) => {
                this.initList = res2.result.columnsInfoModels.map((item) => {
                  if (
                    item.dictType === "declareImg" ||
                    item.dictType === "declareGoods"
                  ) {
                    item.checked = true;
                  }
                  return item;
                });
                this.columnsInfoModels = this.initList;
                if (this.$refs.hmform) {
                  this.$refs.hmform.list = this.initList;
                }
                this.ruleForm.actDesc = res2.result.actDesc;
                this.listHeaderImgUrl = res2.result.mainImgUrl;
              });
          }
          this.detailsDialogVisible = true;
        });
    },
    async edit(row, index, type) {
      // 搭配活动逻辑
      if (row.rewardMode == "collocation") {
        this.$router.push({
          path: "/guiderCommission/addMatchActivityManagement",
          type: "add",
          query: {
            storeCode: this.$route.query.storeCode,
            row: JSON.stringify({
              rewardRuleId: row.rewardRuleId,
              rewardName: row.rewardName,
            }),
            type,
            showAudit: true,
          },
        });
        return;
      }

      // 原有逻辑
      this.selectActivityIndex = index;
      this.row = JSON.parse(JSON.stringify(row));
      this.dialogVisibleEdit = true;
      const { result } = await this.$store.dispatch(
        "copySupplierRewardRuleInfo",
        {
          rewardRuleId: row.rewardRuleId,
        }
      );
      this.ruleForm.applyDepartIds = [];
      this.ruleForm.rewardStartDate = result.rewardStartDate;
      this.ruleForm.rewardEndDate = result.rewardEndDate;
      this.ruleForm.rewardMode = result.rewardMode;
      result.storeDepartInfoModelList.forEach((v) => {
        this.ruleForm.applyDepartIds.push(v.id);
        // this.ruleForm.applyDepartNames.push(v.departName);
      });
      this.applDepartNames = result.storeDepartInfoModelList
        .map((o) => o.departName)
        .join(",");
      this.shopList = result.storeBasicInfoModelList;
      this.addGoodsList = result.ruleGoodsList;
      this.getAddGoodsList();
      this.getAddShopList();
      // this.addGoodsListNew = result.ruleGoodsList;
      this.ruleFormEdit.autoOfflineDaysLimt = JSON.stringify(
        JSON.parse(result.autoOfflineDaysLimt)
      );
      this.numLimt = JSON.stringify(JSON.parse(result.autoOfflineDaysLimt));
      // this.queryStoreBoxList();
      this.initCheckShopDeleted()
      this.$forceUpdate();
    },
    toApplyList(row, index) {
      this.$router.push({
        path: "/guiderCommission/viewReservitionList2",
        query: {
          supplierCode: this.$route.query.storeCode,
          id: row.relPasId,
          // rewardRuleId: row.rewardRuleId
        },
      });
      // this.$router.push({
      //   path: '/activityCenter/bookingOrderList',
      //   query: {
      //     supplierCode: this.$route.query.storeCode,
      //     // rewardRuleId: row.rewardRuleId
      //   }
      // })
    },

    // 复制活动
    async copy(row, index) {
      const that = this;
      // 搭配活动逻辑
      if (row.rewardMode === "collocation") {
        this.$router.push({
          path: "/guiderCommission/addMatchActivityManagement",
          query: {
            storeCode: this.$route.query.storeCode,
            rewardRuleId: row.rewardRuleId,
          },
        });
        return;
      }
      // 原有逻辑
      this.selectActivityIndex = index;
      this.type = "copy";
      this.dialogVisible = true;

      const { result } = await this.$store.dispatch(
        "copySupplierRewardRuleInfo",
        {
          rewardRuleId: row.rewardRuleId,
        }
      );
      if (result.rewardMode === "tiktokLikePas") {
        this.$store
          .dispatch("subActivityDetails", {
            id: result.relPasId,
          })
          .then((res2) => {
            console.log(res2);

            this.initList = res2.result.columnsInfoModels.map((item) => {
              if (
                item.dictType === "declareImg" ||
                item.dictType === "declareGoods"
              ) {
                item.checked = true;
              }
              return item;
            });
            this.columnsInfoModels = this.initList;
            if (this.$refs.hmform) {
              this.$refs.hmform.list = this.initList;
            }
            this.ruleForm.actDesc = res2.result.actDesc;
            this.listHeaderImgUrl = res2.result.mainImgUrl;
          });
      }

      for (let key in this.ruleForm) {
        if (key !== "applDepartIds") {
          this.ruleForm[key] = result[key];
        }
      }
      this.ruleForm.applyDepartIds = [];
      this.ruleForm.applyDepartNames = [];
      this.ruleForm.applDepartId = result.storeDepartInfoModelList;
      result.storeDepartInfoModelList.forEach((v) => {
        this.ruleForm.applyDepartIds.push(v.id);
        this.ruleForm.applyDepartNames.push(v.departName);
      });
      this.ruleForm.upperLimitSwitch =
        result.upperLimitSwitch == 1 ? true : false;
      this.ruleForm.requiredGoodsMode =
        result.requiredGoodsMode == "yes" ? true : false;
      if (
        result.requiredGoodsLimitInfo &&
        result.requiredGoodsLimitInfo.supplierGoodsInfoModelList
      ) {
        let rightOption = [];
        let leftOption = [];
        result.ruleGoodsList.forEach((item) => {
          if (item.composeId) {
            rightOption.push(item);
          } else {
            leftOption.push(item);
          }
        });

        that.rightOption3 = rightOption;
        setTimeout(() => {
          that.$refs.providerTransfer.handleRightCheckAllChange(true);
        }, 0);
        this.copyLeftOption3 = leftOption; // 左侧数据
      }
      this.addGoodsList = result.ruleGoodsList;
      // this.addGoodsListNew = result.ruleGoodsList;
      this.getAddGoodsList();
      this.shopList = result.storeBasicInfoModelList;
       this.getAddShopList()
      setTimeout(() => {
        if (this.$refs.cascader) {
          this.$refs.cascader.presentText = result.storeDepartInfoModelList
            .map((o) => o.departName)
            .join(",");
        }
        this.$refs.hmDateSelect.runningTimeType =
          result.dateConfigMode === "general" ? "all" : "special";

        if (this.$refs.hmDateSelect.runningTimeType === "all") {
          // 选择全时段
          this.$refs.hmDateSelect.ruleDateAndTime = [
            `${result.rewardStartDate} 00:00:00`,
            `${result.rewardEndDate} 23:59:59`,
          ];
        } else if (this.$refs.hmDateSelect.runningTimeType === "special") {
          // 选择特定时段
          // step1.dateConfigRange = dateConfigRange.sort(
          //   this.sortTime("promotionStartTime")
          // );
          this.$refs.hmDateSelect.ruleDate = [
            result.rewardStartDate,
            result.rewardEndDate,
          ];
          // step1.rewardStartDate = ruleDate[0];
          // step1.rewardEndDate = ruleDate[1];
          this.$refs.hmDateSelect.dateType =
            result.dateType === "day" ? "date" : result.dateType;

          // step1.dateType = dateType === "day" ? "date" : dateType;
          // if (this.$refs.hmDateSelect.dateType === "day") {
          //   step1.dateValue = dateValue.sort();
          // } else if (this.$refs.hmDateSelect.dateType === "week") {
          //   step1.dateValue = week.sort();
          // } else if (this.$refs.hmDateSelect.dateType === "month") {
          //   step1.dateValue = daysList;
          // }
        }
        // this.supplierGoodsInfoCheckGoods(result.ruleGoodsList);
      }, 0);
    },
    onLine(row, state) {
      let msg = state === "yes" ? "上线?" : "下线?";
      this.$confirm("是否确认" + msg, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        this.editRuleState(row.rewardRuleId, state);
      });
    },
    editRuleState(rewardRuleId, state) {
      let params = {
        rewardRuleId: rewardRuleId,
        enabledState: state,
      };
      return this.$store.dispatch("editRuleState", params).then((res) => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.queryList();
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisibleEdit = false;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    resetRuleForm() {
      this.step = 1;
      if (this.$refs.ruleForm) {
        // 重置规则
        this.$refs.ruleForm.resetFields();
        this.$refs.hmDateSelect.runningTimeType = "all";
        this.$refs.hmDateSelect.ruleDateAndTime = "";
        this.$refs.hmDateSelect.ruleDate = [];
        this.$refs.hmDateSelect.dateType = "";
        this.$refs.hmDateSelect.week = [];
        this.$refs.hmDateSelect.daysList = [];
      }
      if (this.$refs.ruleFormEdit) {
        this.$refs.ruleFormEdit.resetFields();
      }
      this.ruleForm.applyDepartIds = [];
      this.applDepartNames = "";
      this.ruleForm.applDepartId = [];
      this.value = "";
      this.shopList = [];
      this.shopListNew = []
      this.addGood = {};
      this.ruleForm.rewardValue = "";
      this.ruleForm.ruleRelModelList = [
        {
          rewardNumberLimit: "",
          rewardValue: "",
          index: 0,
        },
      ];
      this.addGoodsList = [];
      this.addGoodsListNew = [];
      this.initList = [];
      this.ruleForm.actDesc = "";
      this.listHeaderImgUrl = "";
      this.hmFormDisabled = false;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    pagingLog(page) {
      this.currentPageLog = page;
      this.queryLogList();
    },
    handleSizeChangeLog(size) {
      this.currentPageLog = 1;
      this.pageSizeLog = size;
      this.queryLogList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // queryList() {
    //   let params = {
    //     pageSize: this.pageSize,
    //     pageNo: this.currentPage,
    //     supplierCode: this.$route.query.storeCode,
    //   };
    //   const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
    //   console.log("searchCondition", searchCondition);

    //   searchCondition[this.searchCondition.queryType] =
    //     searchCondition.keyWords;
    //   if (
    //     searchCondition.applyDepartIds &&
    //     searchCondition.applyDepartIds.length > 0
    //   ) {
    //     searchCondition.applyDepartId =
    //       searchCondition.applyDepartIds[
    //         searchCondition.applyDepartIds.length - 1
    //       ];
    //   }
    //   Object.assign(params, searchCondition);
    //   console.log("params", params);

    //   this.setParamsCookie();
    //   return this.$store.dispatch("querySupplierRewardRuleInfoList", params);
    // },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        supplierCode: this.$route.query.storeCode,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      console.log("searchCondition", searchCondition);

      searchCondition[this.searchCondition.queryType] = searchCondition.keyWords;
      if (searchCondition.applyDepartIds && searchCondition.applyDepartIds.length > 0) {
        searchCondition.applyDepartId = searchCondition.applyDepartIds[searchCondition.applyDepartIds.length - 1];
      }
      Object.assign(params, searchCondition);
      console.log("params", params);

      this.setParamsCookie();
      return this.$store.dispatch("querySupplierRewardRuleInfoList", params).then(response => {
        if (response.result.records.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          return this.queryList();
        }
        return response;
      });
    },
    setParamsCookie() {
      setCookie({
        key: "redpackageActivityListParamsNew" + this.$route.query.storeCode,
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "redpackageActivityListParamsNew" + this.$route.query.storeCode,
        type: "session",
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryStoreBoxList(query) {
      let params = {
        applyDepartIds: this.ruleForm.applyDepartIds,
        storeName: query,
        supplierCode: this.$route.query.storeCode,
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      // Object.assign(params, searchCondition);
      return this.$store.dispatch("queryDepartBindingStoreComboBoxNew", params);
    },
    async initCheckShopDeleted() {
      try {
        await this.queryStoreBoxList(); // 等待接口完成
        this.checkShopDeleted();        // 再调用检查逻辑
      } catch (error) {
        console.error('初始化失败:', error.message);
      }
    },
    checkShopDeleted() {  //判断商户是否删除和取消关联
      const validStoreCodes = new Set(this.departBindingStoreBox.map(item => item.storeCode));
      this.shopList = this.shopList.filter(shop => {
        const exists = validStoreCodes.has(shop.storeCode);
        if (!exists) this.shopDeletedList.push(shop);
        return exists;
      });
      this.getAddShopList()
      this.shopDeletedDialogVisible = this.shopDeletedList.length > 0;
    },
    shopDeletedDialogClose() {
      this.shopDeletedList = []
      this.shopDeletedDialogVisible = false
    },
    newGood() {
      this.dialogVisibleGood = true;
    },
    addAct() {
      this.isShowRewards = 'fixed'
      this.type = "add";
      this.initList = [];
      this.ruleForm.actDesc = "";
      this.listHeaderImgUrl = "";
      this.dialogVisible = true;
      this.rightOption3 = [];
      this.copyLeftOption3 = [];
      this.leftOption3 = [];
      this.ruleForm.requiredGoodsMode = false;
      this.ruleForm.upperLimitSwitch = false;
    },
    async step3Products() {
      try {
        this.drawerStep3Products = true;
        const { result } = await this.$store.dispatch(
          "queryRewardGoodsImportEsPageList",
          {
            pageNo: this.step3ProductsPage,
            pageSize: this.step3ProductsSize,
            storeCode: this.$route.query.storeCode
          }
        );
        this.step3ProductsRecords = result.records;
        // this.step3ProductsRecords = this.step3ProductsRecords.filter(item => {
        //   return item.storeCode === this.$route.query.storeCode
        // })
        this.step3ProductsSize = result.size;
        this.step3ProductsTotal = result.total;
        console.log("addAct:::", result);
      } catch (error) {}
    },

    step3ProductsSizeChange(val) {
      this.step3ProductsSize = val;
      this.step3ProductsPage = 1;
      this.step3Products();
    },
    step3ProductsCurrentChange(val) {
      this.step3ProductsPage = val;
      this.step3Products();
    },
    /**
     * @desc 详情弹窗关闭
     */
    handleDetailDialogClose() {
      this.initList = [];
      this.selfCreatedCurrentPage = 1
      this.repeatGoodsPageSize = 10
      this.ruleForm.actDesc = "";
      this.listHeaderImgUrl = "";
      
      this.detailsDialogVisible = false;
    },
    // remoteMethod(query) {

    //   if (query !== "") {
    //     this.loading = true;
    //     // this.queryStoreBoxList(query).then(res=>{
    //     //   if(res.code==="0"){

    //     //     this.options = res.result.filter(item => {
    //     //     return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //     //   });
    //     //   }
    //     // })
    //     setTimeout(() => {
    //       this.loading = false;
    //       this.options = this.list.filter(item => {
    //         return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //       });
    //     }, 200);
    //   } else {
    //     this.options = [];
    //   }
    // },
    submitEdit(formName) {
      // editRewardRuleInfo
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.row.rewardName = this.row.rewardName
            .replace("（", "(")
            .replace("）", ")");
          let params = {
            rewardRuleId: this.row.rewardRuleId,
            rewardName: this.row.rewardName,
            autoOfflineDaysLimt: this.ruleFormEdit.autoOfflineDaysLimt,
            storeBasicInfoModelList: this.shopList,
            ruleGoodsList: [...new Set([...this.addGoodsList])],
          };
          this.$store.dispatch("editRewardRuleInfo", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisibleEdit = false;
              this.queryList();

              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
            }
          });
        }
      });
    },
    async queryVerifyRewardRuleName() {
      let params = {
        supplierCode: this.$route.query.storeCode,
        rewardName: this.ruleForm.rewardName
      };
       try {
         const { code } = await this.$store.dispatch(
        "verifyRewardRuleName",
        params
      );
        if (code !='0') {
          return false
        }else {
          return true
        }
      } catch (error) {
        return false
      }
    },
    async submitRuleForm(formName) {
      if(this.step ==1) {
          if(this.ruleForm.rewardName) {
            if(!await this.queryVerifyRewardRuleName()) {
              return
            }
         }
        }
      console.log("提交代码级别",this.step);
      // 必有商品的逻辑
      if (this.stepsComputed.length == 5) {
        console.log("提交代码级别::", this.stepsComputed.length);
        console.log("提交代码级别::", this.step);
        if (this.step === 1) {
          if (this.type == "copy") {
              this.initCheckShopDeleted()
            }
          if (this.ruleForm.rewardMode === "tiktokLikePas") {
            let params = {
              pageNo: this.currentPage,
              pageSize: this.pageSize,
              storeCode: this.$route.query.storeCode,
              configType: "supplier",
            };
            const { result } = await this.$store.dispatch(
              "querySupplierAuditList",
              params
            );
            this.supplierAuditList = result.records;
            const some = this.supplierAuditList.some(
              (item) => item.paramCode === "tiktokLikePasAudit"
            );
            if (!some) {
              return this.$message.warning("请先配置报名审核规则");
            }
          }
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (
                !this.ruleForm.ruleRelModelList ||
                this.ruleForm.ruleRelModelList.length < 1
              ) {
                this.$message({
                  message: "请填写活动规则!",
                  type: "warning",
                });
                return false;
              }
              const {
                runningTimeType,
                ruleDateAndTime,
                ruleDate,
                dateType,
                dateValue,
                // dateConfigRange,
                week,
                daysList,
              } = this.$refs.hmDateSelect;
              let step1 = {};
              step1.dateConfigMode =
                runningTimeType === "all" ? "general" : "special";
              if (runningTimeType === "all") {
                // 选择全时段
                step1.rewardStartDate = ruleDateAndTime.length
                  ? ruleDateAndTime[0]
                  : "";
                step1.rewardEndDate = ruleDateAndTime.length
                  ? ruleDateAndTime[1]
                  : "";
              } else if (runningTimeType === "special") {
                // 选择特定时段
                // step1.dateConfigRange = dateConfigRange.sort(
                //   this.sortTime("promotionStartTime")
                // );
                step1.rewardStartDate = ruleDate[0];
                step1.rewardEndDate = ruleDate[1];
                step1.dateType = dateType === "day" ? "date" : dateType;
                if (dateType === "day") {
                  step1.dateValue = dateValue.sort();
                } else if (dateType === "week") {
                  step1.dateValue = week.sort();
                } else if (dateType === "month") {
                  step1.dateValue = daysList;
                }
              }
              if (this.type === "add") {
                this.ruleForm.applyDepartNames = [];
                this.ruleForm.applyDepartIds = [];
                this.ruleForm.applDepartId.forEach((v) => {
                  this.ruleForm.applyDepartIds.push(v[v.length - 1].value);
                  this.ruleForm.applyDepartNames.push(v[v.length - 1].label);
                });
              }
              this.ruleForm.ruleRelModelList.forEach((v) => {
                v.rewardNumberLimit = new Number(v.rewardNumberLimit);
                if (
                  this.ruleForm.rewardMode === "sub" ||
                  this.ruleForm.rewardMode === "tiktokLikePas"
                ) {
                  v.rewardSubNum = new Number(v.rewardSubNum);
                }
              });
              this.ruleForm.autoOfflineDaysLimt = new Number(
                this.ruleForm.autoOfflineDaysLimt
              );
              Object.assign(this.ruleForm, step1);
              this.step = this.step + 1;
            } else {
              return false;
            }
          });
        } else if (this.step === 2) {
          if (this.shopList.length > 0) {
            this.step = this.step + 1;
            this.queryMicroShopGoodsList();
            if (this.type == "copy") {
              this.supplierGoodsInfoCheckGoods(this.addGoodsList);
            }
          } else {
            this.$message({
              message: "请添加商户!",
              type: "warning",
            });
          }
        } else if (this.step === 3) {
          this.leftOption3 = [...new Set([...this.addGoodsList])];
          // if(this.type == "copy"){
          //   this.leftOption3 = this.copyLeftOption3;
          // }

          if (this.addGoodsList.length > 0) {
            let flag = false;
            if (
              this.ruleForm.rewardMode === "sub" ||
              this.ruleForm.rewardMode === "tiktokLikePas"
            ) {
              this.addGoodsList.forEach((v) => {
                if (
                  v.rewardBaseMoney === "" ||
                  (!v.rewardBaseMoney || v.rewardBaseMoney == 0)
                ) {
                  flag = true;
                }
              });
            }

            if (flag) {
              this.$message({
                message: "请输入正确的商品单件奖励!",
                type: "warning",
              });
            } else {
              this.step = this.step + 1;
            }
          } else {
            this.$message({
              message: "请添加商品!",
              type: "warning",
            });
          }
          console.log(3333333);
          this.addGoodsListNew = this.addGoodsList.slice(
            0,
            this.theTotalNumberOfUnits2
          );
          // this.leftOption3 = [...new Set([...this.leftOption3])]
        } else if (this.step === 4) {
          console.log(this.rightOption3);
          console.log(this.leftOption3);
          console.log(this.type);

          if (this.rightOption3.length == 0) {
            this.$message({
              message: "请添加关联商品!",
              type: "warning",
            });
            return;
          }
          let isCarryOut = true;
          this.ruleForm.ruleRelModelList.forEach((v) => {
            if (!v.rewardRequiredNum) {
              isCarryOut = false;
            }
          });

          if (!isCarryOut) {
            this.$message({
              message: "请设置限制数量!",
              type: "warning",
            });
            return;
          }

          if (this.ruleForm.requiredGoodsMode && this.rightOption3) {
            this.addGoodsList = [
              ...new Set([...this.rightOption3, ...this.addGoodsList]),
            ];
          }

          const uniqueArray = this.addGoodsList.reduce((acc, curr) => {
            const found = acc.find(
              (obj) => obj.supplierGoodsId === curr.supplierGoodsId
            );
            if (!found) {
              acc.push(curr);
            }
            return acc;
          }, []);

          this.addGoodsList = uniqueArray;
          console.log(this.addGoodsList);

          this.step = this.step + 1;
        } else if (this.step === 5) {
          let params = {};
          params.applyStoreCodes = this.shopList.map((v) => v.storeCode);
          params.supplierCode = this.$route.query.storeCode;
          params.ruleGoodsList = [...new Set([...this.addGoodsList])];
          this.ruleForm.upperLimitSwitch = this.ruleForm.upperLimitSwitch
            ? 1
            : 0;
          this.ruleForm.rewardName = this.ruleForm.rewardName
            .replace("（", "(")
            .replace("）", ")");
          Object.assign(params, this.ruleForm);
          console.log("---params---", {
            ...params,
            columnsInfoModels: this.columnsInfoModels,
          });
          let relPasId = "";
          if (params.rewardMode === "tiktokLikePas") {
            if (!this.ruleForm.actDesc) {
              return this.$message.warning("请设置图文详情！");
            }
            if (!this.listHeaderImgUrl) {
              return this.$message.warning("请上传主图！");
            }
            if (this.columnsInfoModels.length < 1 || !this.columnsInfoModels) {
              return this.$message.warning("请添加关联表单数据！");
            }
            const data = await this.$store.dispatch("addSubActivity", {
              ...params,
              columnsInfoModels: this.columnsInfoModels,
              mainImgUrl: this.listHeaderImgUrl,
              actStatus: 1,
              isShow: "yes",
              formStatus: "open",
              actStartTime: params.rewardStartDate,
              actEndTime: params.rewardEndDate,
              applyStartTime: params.rewardStartDate,
              applyEndTime: params.rewardEndDate,
              actMemberUpperLimitFalse: 0,
              actMemberUpperLimit: 99999,
              actName: params.rewardName + "预约活动",
              round: [
                {
                  actSite: "活动地点明细",
                  subscribeRound: [
                    {
                      actAddressType: "address",
                      actSite: "活动地点明细",
                      actRound: "活动场次",
                      onceActMemberUpperLimit: 9999,
                      onceSinglePurchaseQuantity: null,
                      onceSingleApplyUpperLimit: null,
                      actCostMoney: 0.0,
                      actCostIntegral: 0,
                      registeredAmount: 1,
                      delFlag: "0",
                      costType: "free",
                      cost: null,
                      payType: null,
                      hidden: null,
                      sort: 0,
                      siteNum: 0,
                    },
                  ],
                  hidden: null,
                  costType: "either",
                  actAddressType: null,
                  sort: null,
                },
              ],
            });
            if (data.code === "0") {
              relPasId = data.result.activity.id;
            }
          }
          if (params.rewardMode == "fixed") {
            params.requiredGoodsMode = params.requiredGoodsMode ? "yes" : "no";
            params.upperLimitSwitch = params.upperLimitSwitch ? 1 : 0;
          } else {
            delete params.requiredGoodsMode;
            delete params.upperLimitSwitch;
          }

          params.requiredGoodsLimitInfo = {
            goodsNum: this.rightOption3.length,
            supplierGoodsInfoModelList: this.rightOption3,
          };
          console.log("提交代码函数：：params", params);
          console.log("提交代码函数：：relPasId", relPasId);

          const res = await this.$store.dispatch(
            "saveSupplierRewardRuleInfoList",
            { ...params, relPasId }
          );
          console.log("提交代码函数：：", res);
          if (res.code === "0") {
            this.columnsInfoModels = [];
            if (this.$refs.hmform) {
              this.$refs.hmform.list = [];
            }
            this.ruleForm.actDesc = "";
            this.listHeaderImgUrl = "";
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.dialogVisible = false;
            this.queryList();
            this.step = 1;
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
          }
        }
        return false;
      }
      console.log("当前所在的进度位置：：", this.step);
      // 一般逻辑
      if (this.step === 1) {
         if (this.type == "copy") {
              this.initCheckShopDeleted()
            }
        if (this.ruleForm.rewardMode === "tiktokLikePas") {
          let params = {
            pageNo: this.currentPage,
            pageSize: this.pageSize,
            storeCode: this.$route.query.storeCode,
            configType: "supplier",
          };
          const { result } = await this.$store.dispatch(
            "querySupplierAuditList",
            params
          );
          this.supplierAuditList = result.records;
          const some = this.supplierAuditList.some(
            (item) => item.paramCode === "tiktokLikePasAudit"
          );
          if (!some) {
            return this.$message.warning("请先配置报名审核规则");
          }
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (
              !this.ruleForm.ruleRelModelList ||
              this.ruleForm.ruleRelModelList.length < 1
            ) {
              this.$message({
                message: "请填写活动规则!",
                type: "warning",
              });
              return false;
            }
            const {
              runningTimeType,
              ruleDateAndTime,
              ruleDate,
              dateType,
              dateValue,
              // dateConfigRange,
              week,
              daysList,
            } = this.$refs.hmDateSelect;
            let step1 = {};
            step1.upperLimitSwitch = this.ruleForm.upperLimitSwitch;
            step1.dateConfigMode =
              runningTimeType === "all" ? "general" : "special";
            if (runningTimeType === "all") {
              // 选择全时段
              step1.rewardStartDate = ruleDateAndTime.length
                ? ruleDateAndTime[0]
                : "";
              step1.rewardEndDate = ruleDateAndTime.length
                ? ruleDateAndTime[1]
                : "";
            } else if (runningTimeType === "special") {
              // 选择特定时段
              // step1.dateConfigRange = dateConfigRange.sort(
              //   this.sortTime("promotionStartTime")
              // );
              step1.rewardStartDate = ruleDate[0];
              step1.rewardEndDate = ruleDate[1];
              step1.dateType = dateType === "day" ? "date" : dateType;
              if (dateType === "day") {
                step1.dateValue = dateValue.sort();
              } else if (dateType === "week") {
                step1.dateValue = week.sort();
              } else if (dateType === "month") {
                step1.dateValue = daysList;
              }
            }
            if (this.type === "add") {
              this.ruleForm.applyDepartNames = [];
              this.ruleForm.applyDepartIds = [];
              this.ruleForm.applDepartId.forEach((v) => {
                this.ruleForm.applyDepartIds.push(v[v.length - 1].value);
                this.ruleForm.applyDepartNames.push(v[v.length - 1].label);
              });
            }
            this.ruleForm.ruleRelModelList.forEach((v) => {
              v.rewardNumberLimit = new Number(v.rewardNumberLimit);
              if (
                this.ruleForm.rewardMode === "sub" ||
                this.ruleForm.rewardMode === "tiktokLikePas"
              ) {
                v.rewardSubNum = new Number(v.rewardSubNum);
              }
            });
            this.ruleForm.autoOfflineDaysLimt = new Number(
              this.ruleForm.autoOfflineDaysLimt
            );

            Object.assign(this.ruleForm, step1);
            this.step = this.step + 1;
          } else {
            return false;
          }
        });
      } else if (this.step === 2) {
        if (this.shopList.length > 0) {
          this.step = this.step + 1;
          this.queryMicroShopGoodsList();
          if (this.type == "copy") {
            this.supplierGoodsInfoCheckGoods(this.addGoodsList);
          }
        } else {
          this.$message({
            message: "请添加商户!",
            type: "warning",
          });
        }
      } else if (this.step === 3) {
        console.log("goods", this.addGoodsList);
        this.leftOption3 = this.addGoodsList;
        if (this.addGoodsList.length > 0) {
          let flag = false;
          if (
            this.ruleForm.rewardMode === "sub" ||
            this.ruleForm.rewardMode === "tiktokLikePas"
          ) {
            this.addGoodsList.forEach((v) => {
              if (
                v.rewardBaseMoney === "" ||
                (!v.rewardBaseMoney || v.rewardBaseMoney == 0)
              ) {
                flag = true;
              }
            });
          }

          if (flag) {
            this.$message({
              message: "请输入正确的商品单件奖励!",
              type: "warning",
            });
          } else {
            this.step = this.step + 1;
          }
        } else {
          this.$message({
            message: "请添加商品!",
            type: "warning",
          });
        }
      } else if (this.step === 4) {
        let params = {};
        params.applyStoreCodes = this.shopList.map((v) => v.storeCode);
        params.ruleGoodsList = [...new Set([...this.addGoodsList])];
        params.supplierCode = this.$route.query.storeCode;
        // this.ruleForm.upperLimitSwitch = this.ruleForm.upperLimitSwitch ? 1 : 0;
        this.ruleForm.rewardName = this.ruleForm.rewardName
          .replace("（", "(")
          .replace("）", ")");
        Object.assign(params, this.ruleForm);
        console.log("---params---", {
          ...params,
          columnsInfoModels: this.columnsInfoModels,
        });
        let relPasId = "";

        if (params.rewardMode === "tiktokLikePas") {
          if (!this.ruleForm.actDesc) {
            return this.$message.warning("请设置图文详情！");
          }
          if (!this.listHeaderImgUrl) {
            return this.$message.warning("请上传主图！");
          }
          if (this.columnsInfoModels.length < 1 || !this.columnsInfoModels) {
            return this.$message.warning("请添加关联表单数据！");
          }
          const data = await this.$store.dispatch("addSubActivity", {
            ...params,
            columnsInfoModels: this.columnsInfoModels,
            mainImgUrl: this.listHeaderImgUrl,
            actStatus: 1,
            isShow: "yes",
            formStatus: "open",
            actStartTime: params.rewardStartDate,
            actEndTime: params.rewardEndDate,
            applyStartTime: params.rewardStartDate,
            applyEndTime: params.rewardEndDate,
            actMemberUpperLimitFalse: 0,
            actMemberUpperLimit: 99999,
            actName: params.rewardName + "预约活动",
            round: [
              {
                actSite: "活动地点明细",
                subscribeRound: [
                  {
                    actAddressType: "address",
                    actSite: "活动地点明细",
                    actRound: "活动场次",
                    onceActMemberUpperLimit: 9999,
                    onceSinglePurchaseQuantity: null,
                    onceSingleApplyUpperLimit: null,
                    actCostMoney: 0.0,
                    actCostIntegral: 0,
                    registeredAmount: 1,
                    delFlag: "0",
                    costType: "free",
                    cost: null,
                    payType: null,
                    hidden: null,
                    sort: 0,
                    siteNum: 0,
                  },
                ],
                hidden: null,
                costType: "either",
                actAddressType: null,
                sort: null,
              },
            ],
          });
          if (data.code === "0") {
            relPasId = data.result.activity.id;
          }
        }
        if (params.rewardMode == "fixed") {
          params.upperLimitSwitch = params.upperLimitSwitch ? 1 : 0;
        } else {
          delete params.upperLimitSwitch;
        }
        //   this.importGoodsEsRecordId ? "saveSupplierRewardRuleInfoImportGoodsEs": "saveSupplierRewardRuleInfoList",
        const res = await this.$store.dispatch(
          "saveSupplierRewardRuleInfoList",
          { ...params, relPasId }
        );
        if (res.code === "0") {
          this.columnsInfoModels = [];
          if (this.$refs.hmform) {
            this.$refs.hmform.list = [];
          }
          this.ruleForm.actDesc = "";
          this.listHeaderImgUrl = "";
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.queryList();
          this.step = 1;
          setTimeout(() => {
            this.resetRuleForm();
          }, 0);
        }
      }
    },

    detailColor({ row, rowIndex }) {
      if (rowIndex < this.goodsNumDetail) {
        return "red_table";
      }
      return "";
    },
    addGoodsListRCN({ row, rowIndex }) {
      if (
        this.ruleForm.requiredGoodsMode &&
        this.rightOption3 &&
        rowIndex < this.rightOption3.length
      ) {
        return "red_table";
      }
      return "";
    },
    sortTime(property) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return (
          new Date(new Date().toLocaleDateString() + " " + value1).getTime() -
          new Date(new Date().toLocaleDateString() + " " + value2).getTime()
        );
      };
    },
    keep() {},
    swithRunningTimeType() {
      this.$refs.validatorTime.clearValidate();
    },
    getChecked(selection) {
      this.checkedRow = selection;
      // this.checkedRow = selection.map(v => v.spuId);
    },
    addShop() {
      const list = this.checkedMerchantRow;
      let json = this.shopList.concat(list);
      let newJson = [];
      for (let item1 of json) {
        let flag = true;
        for (let item2 of newJson) {
          if (item1.storeCode == item2.storeCode) {
            flag = false;
          }
        }
        if (flag) {
          newJson.push(item1);
        }
      }
      this.shopList = newJson;
      // this.shopList.map(v => {
      //   if (v.storeCode === this.value) {
      //     show = true;
      //   }
      // });
      // if (!show) {
      //   this.shopList.push({
      //     storeName: this.$refs.selectCh.selectedLabel,
      //     storeCode: this.value
      //   });
      // }
      // this.value = "";
      this.getAddShopList();
      this.merchantDialogVisible = false;

    },
    remove(row) {
      let list = [];
      list.push(row);
      this.shopList = getSubtract(this.shopList, list, "storeCode");
      this.shopListNew = getSubtract(this.shopList, list, "storeCode");
       this.getAddShopList();
    },
    addGoods() {
      this.dialogVisibleGoods = true;
      // this.queryMicroShopGoodsList();
      this.$store.dispatch("queryHemiaoBrandComboBox", {
        supplierCode: this.$route.query.storeCode,
      });
    },
    searchGoods() {
      this.currentMicroPage = 1;
      this.queryMicroShopGoodsList();
    },
    addMerchandise() {
      this.addGood.storeCode = this.$route.query.storeCode;
      return this.$store
        .dispatch("saveSupplierGoodsInfoList", this.addGood)
        .then((res) => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success",
            });
            this.queryMicroShopGoodsList();
            this.addGood = {};
          }
        });
    },
    getMerchantChecked(selection) {
      this.checkedMerchantRow = selection;
    },
    getDelChecked(selection) {
      this.checkedDelRow = selection.map((v) => v.rewardRuleId);
    },
    batchDelete() {
      if (this.checkedDelRow.length) {
        let say = "删除已选" + this.checkedDelRow.length + "条数据";
        this.$confirm(say, "提示", {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning",
        }).then(() => {
          let params = {
            rewardRuleIds: this.checkedDelRow,
            supplierCode: this.$route.query.storeCode,
          };
          this.$store
            .dispatch("delSupplierRewardRuleInfoList", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.queryList();
              }
            });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    openTimeBatch() {
      if (this.checkedDelRow.length) {
        this.dialogVisibleTimeBatch = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    batchSetting() {
      if (!this.batchCondition.endTime && !this.batchCondition.addDays) {
        this.$message({
          message: "请选择结束时间或者请选择活动下线天数",
          type: "warning",
        });
        return;
      }
      let say = "修改已选" + this.checkedDelRow.length + "条数据的结束时间";
      this.$confirm(say, "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        let params = {};
        if (this.batchCondition.endTime) {
          params = {
            rewardEndDate: this.batchCondition.endTime,
            rewardRuleIds: this.checkedDelRow,
            // supplierCode: this.$route.query.storeCode,
          };
          console.log("活动结束时间params:", params);
          this.$store
            .dispatch("editRewardRuleEndDateBatch", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.batchCondition.endTime = "";
                this.dialogVisibleTimeBatch = false;
                this.queryList();
              }
            });
        }
        if (this.batchCondition.addDays) {
          params = {
            rewardRuleIdList: this.checkedDelRow,
            addDays: this.batchCondition.addDays,
            // supplierCode: this.$route.query.storeCode,
          };
          console.log("活动下线天数params:", params);
          this.$store
            .dispatch("batchIncreaseAutoOfflineDaysLimt", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });
                this.batchCondition.endTime = "";
                this.dialogVisibleTimeBatch = false;
                this.queryList();
              }
            });
        }
      });
    },
    editAddGoods() {
      this.dialogVisibleGoods = true;
      this.currentMicroPage = 1;
      // this.pageMicroSize = 10;
      this.queryMicroShopGoodsList();
    },
    pagingMicro(page) {
      this.currentMicroPage = page;
      this.queryMicroShopGoodsList();
    },
    handleSizeMicroChange(size) {
      console.log(111111);
      console.log(size);
      this.currentMicroPage = 1;
      this.pageMicroSize = size;
      this.queryMicroShopGoodsList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryMicroShopGoodsList() {
      let params = {
        pageSize: this.pageMicroSize,
        pageNo: this.currentMicroPage,
        storeCode: this.$route.query.storeCode,
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );

      Object.assign(params, searchDialogCondition);

      return this.$store.dispatch("querySupplierGoodsInfoList", params);
    },
    affirm() {
      if (this.checkedRow.length) {
        // console.log('checkedRow',this.checkedRow);
        this.supplierGoodsInfoCheckGoods(this.checkedRow);
        // console.log("this.addGoodsList: ", this.addGoodsList);
        this.dialogVisibleGoods = false;
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning",
        });
      }
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.ruleFormGood;
          params.storeCode = this.$route.query.storeCode;
          return this.$store
            .dispatch("saveSupplierGoodsInfoList", params)
            .then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success",
                });

                this.queryMicroShopGoodsList();
                this.dialogVisibleGood = false;
              }
            });
        } else {
          return false;
        }
      });
    },
    removeGoods(row) {
      let list = [];
      list.push(row);
      this.addGoodsList = getSubtract(
        this.addGoodsList,
        list,
        "supplierGoodsId"
      );
      this.addGoodsListNew = getSubtract(
        this.addGoodsListNew,
        list,
        "supplierGoodsId"
      );
      this.getAddGoodsList();
      /*this.addGoodsList.splice(index, 1);*/
    },
    // 活动规则  普通活动
    filterGt0OrListFixed0(i, prop) {
      console.log("普通活动 活动规则", i, prop);
      if (prop !== "rewardSubNum") {
        this.ruleForm.ruleRelModelList[i][
          prop
        ] = this.ruleForm.ruleRelModelList[i][prop].replace(/^(0+)/, ""); //过滤0开头
      }
      console.log("ruleRelModelList::", this.ruleForm.ruleRelModelList);

      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/[^\d]+/g, "");
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
      console.log("最终ruleRelModelList::", this.ruleForm.ruleRelModelList);
      // 新增校验规则
      const currentValue = parseFloat(this.ruleForm.ruleRelModelList[i][prop]);
      console.log("currentValue::", currentValue);
      if (isNaN(currentValue)) {
        return;
      }
      if (i > 0) {
        const prevValue = parseFloat(
          this.ruleForm.ruleRelModelList[i - 1][prop]
        );
        console.log("prevValue::", prevValue);
        if (currentValue <= prevValue) {
          // this.ruleForm.ruleRelModelList[i][prop] = prevValue + 1;
          this.$message.warning(`第${i+1}行第一列的值必须大于上一行的值`);
        }
      }
    },

    filterGt0OrListFixed2(i, prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.ruleRelModelList[i][prop] = this.ruleForm.ruleRelModelList[
        i
      ][prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.ruleForm.ruleRelModelList[i][prop].indexOf(".") < 0 &&
        this.ruleForm.ruleRelModelList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.ruleRelModelList[i][prop] = parseFloat(
          this.ruleForm.ruleRelModelList[i][prop]
        );
      }
    },
    filterMaxDistributionAmount(e) {
      this.ruleForm.maxDistributionAmount = this.ruleForm.maxDistributionAmount.replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.maxDistributionAmount = this.ruleForm.maxDistributionAmount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.maxDistributionAmount = this.ruleForm.maxDistributionAmount.replace(".", "$#*").replace(/\./g, "").replace("$#*", "."); //去除其他"."
      this.ruleForm.maxDistributionAmount = this.ruleForm.maxDistributionAmount.replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.ruleForm.maxDistributionAmount.indexOf(".") < 0 &&
        this.ruleForm.maxDistributionAmount != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.maxDistributionAmount = parseFloat(
           this.ruleForm.maxDistributionAmount
        );
      }
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrGoodsListFixed2(i, prop) {
      this.$forceUpdate();
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.addGoodsList[i][prop] = this.addGoodsList[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.addGoodsList[i][prop].indexOf(".") < 0 &&
        this.addGoodsList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.addGoodsList[i][prop] = parseFloat(this.addGoodsList[i][prop]);
      }
       console.log("普通活动 商品列表",  this.addGoodsList,  this.addGoodsListNew);
    },
    outputExcelMerchant() {
      this.$store.dispatch("storeActivityList", {
        supplierCode: this.$route.query.storeCode,
      });
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
      }, 0);
    },
    handleConcatForm() {
      const list = this.addGoodsList.filter(
        (data) =>
          !this.goodSearchVal ||
          data.goodsName
            .toLowerCase()
            .includes(this.goodSearchVal.toLowerCase()) ||
          data.goodsBarcode
            .toLowerCase()
            .includes(this.goodSearchVal.toLowerCase())
      );
      console.log("---list---", list);
    },
    formDialogConfirm() {
      console.log(this.$refs.hmform);
      this.columnsInfoModels = this.$refs.hmform.list;
      for (let item of this.columnsInfoModels) {
        console.log(item);
        if (!item.columnName) {
          return this.$message.warning("请填写报名项名称");
        }
        if (item.paramInfoModels && item.paramInfoModels.length) {
          for (let item2 of item.paramInfoModels) {
            if (!item2.columnValue) {
              return this.$message.warning("请填写选项值");
            }
            if (!item2.relDataId) {
              return this.$message.warning("请选择关联商品");
            }
          }
        }
      }
      console.log("this.columnsInfoModels", this.columnsInfoModels);
      // if()
      const goods = this.columnsInfoModels.filter(
        (item) =>
          item.checked === true &&
          (item.columnType === "checkbox" || item.columnType === "radio")
      );
      console.log("---goods---", goods);
      const pictures = this.columnsInfoModels.filter(
        (item) => item.checked === true && item.columnType === "picture"
      );
      console.log("---pictures--", pictures);
      // this.formDialogVisible = false
      if (pictures.length === 0) {
        return this.$message.warning("请选择一个申报主图");
      }
      if (pictures.length > 1) {
        return this.$message.warning("只能设置一个申报主图");
      }
      if (goods.length === 0) {
        return this.$message.warning("请选择一个申报主商品");
      }
      if (goods.length > 1) {
        return this.$message.warning("只能设置一个申报主商品");
      }
      this.columnsInfoModels.map((item) => {
        if (
          item.checked === true &&
          (item.columnType === "checkbox" || item.columnType === "radio")
        ) {
          item.dictType = "declareGoods";
        }
        if (item.checked === true && item.columnType === "picture") {
          item.dictType = "declareImg";
        }
      });
      this.formDialogVisible = false;
    },

    toggleShow() {
      this.show = !this.show;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    cropUploadFail() {},
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.listHeaderImgUrl = response.result;
      this.$message({
        type: "success",
        message: "上传成功！",
      });
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning",
      });
    },
    // 上传前对文件的大小的判断
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 300;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning",
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 300k!",
          type: "warning",
        });
      }
      const isSize = new Promise((resolve, reject) => {
        let width = 345;
        let height = 180;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "请上传345*180的图片!",
            type: "warning",
          });
          return Promise.reject();
        }
      );
      return (
        (extension || extension2 || extension3 || extension4) &&
        limitSize &&
        isSize
      );
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.uploadedDetailList.splice(file, 1);
      } else {
        const index = this.uploadedDetailList.findIndex(
          (v) => v === file.response.result
        );
        this.uploadedDetailList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning",
      });
    },
    uploadListDetailSuccess(response) {
      this.uploadedDetailList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！",
      });
    },
    setFirst(i) {
      let tmp = this.uploadedDetailList[0];
      this.uploadedDetailList[0] = this.uploadedDetailList[i];
      this.uploadedDetailList[i] = tmp;
      this.$forceUpdate();
    },
    actAddressTypeChange(item) {
      item.actSite = "";
    },
    cropSuccess() {},
    /**
     * @desc 导出商品导入模板
     */
    outputGoodsExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商品品牌(必填)",
          "商品系列",
          "商品名称(必填)",
          "商品条码(必填)",
          "销售价",
        ];
        const data = [];
        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    /**
     * @desc 导入商品
     */
    importGoodsF(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];

        result.forEach((v) => {
          // v[0] = v[0] ? (v[0] + "").replace(/\s*/g, "") : "";
          // v[1] = v[1] ? (v[1] + "").replace(/\s*/g, "") : "";
          // v[2] = v[2] ? (v[2] + "").replace(/\s*/g, "") : "";
          // v[3] = v[3] ? (v[3] + "").replace(/\s*/g, "") : "";
          // v[4] = v[4] ? (v[4] + "").replace(/\s*/g, "") : "";
          if (v[0] || v[1] || v[2] || v[3] || v[4]) {
            formatResult.push({
              brandName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              seriesName: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              goodsName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
              goodsBarcode: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
              salePrice: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
              storeCode: that.$route.query.storeCode,
            });
          }
        });
        that.$store
          .dispatch("exportGoodsSupplier", formatResult)
          .then((res) => {
            const { code, result } = res;
            if (code === "0") {
              if (result.failList.length > 0) {
                that.errValidGoods2 = true;
                that.errInputResult2 = result.failList;
                that.$message({
                  message: "部分商品导入失败！",
                  type: "warning",
                });
              }
              that.succInputResult2 = result.successList;
              that.searchGoods();
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 刷新件数
    refreshQuantity(row, ind) {
      console.log(row,ind,999999999)
      if (row.rewardNumberLimit == "") {
        return;
      }
      if(ind == 0 || (this.ruleForm.ruleRelModelList[ind].rewardNumberLimit > this.ruleForm.ruleRelModelList[ind-1].rewardNumberLimit) ) {
        this.ruleForm.ruleRelModelList.forEach((v, index) => {
        if (index > ind) {
          v.rewardNumberLimit = Number(row.rewardNumberLimit) + (index - ind);
        }
      });
     }else if(this.ruleForm.ruleRelModelList[ind].rewardNumberLimit < this.ruleForm.ruleRelModelList[ind-1].rewardNumberLimit ) {
        this.$message.close();
        this.$message.error(`第 ${ind + 1} 项的商品件数必须大于上一项的商品件数`);
     }
      // console.log('row.index', ind)
      
    },
    // 刷新金额
    refreshMoney(row, ind) {
      if (row.rewardValue == "" || row.rewardNumberLimit == "") {
        return;
      }
      this.ruleForm.ruleRelModelList.forEach((v, index) => {
        if (index > ind) {
          if (v.rewardNumberLimit == "") {
            v.rewardValue = "";
          } else {
            v.rewardValue =
              (
                (Number(row.rewardValue) / Number(row.rewardNumberLimit)) *
                v.rewardNumberLimit
              ).toFixed(2) * 1;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
.hm-pagination {
  font-family: PingFang SC;
}

.applDepart {
  width: 600px;

  .el-input {
    width: 600px;

    input {
      width: 600px;
    }
  }
}

.el-table .red_table {
  background: #fedeec;
  color: #e50065;
}
</style>
<style lang="scss" scoped>
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.title {
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
}

/deep/ .activity-style {
  background-color: #fce6f0 !important;
}

.priview {
  width: 300px;

  img {
    width: 300px;
  }
}

.align-center {
  align-items: center;
}

.lis {
  width: 660px;
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d2d2d2;
}
.exceeding-upper-limit-setting {
  color: #999;
  margin-top: -10px;
}

.rule-upperLimitSwitch {
  display: inline-block;
  font-size: 12px;
  margin-left: 12px;
  .money {
    color: red;
  }
}

/deep/ .el-pagination__editor.el-input {
    width: 50px !important;
}
/deep/ .main-container .el-select {
    width: 150px !important;
}
</style>
